{
  "app.admin_workflows.account_proof": "חשבון הוכחה",
  "app.admin_workflows.alerts": "התראות",
  "app.admin_workflows.allowed_admin_checks": "מותרים ניהול בדיקות",
  "app.admin_workflows.audit_and_permission_review": "ביקורת ו הרשאה בדוק",
  "app.admin_workflows.audit_entries": "ביקורת רשומות",
  "app.admin_workflows.confirm_the_correct_user_or_occasion_before_taking_action_and_keep_support": "אשר את המשתמש או האירוע הנכונים לפני ביצוע פעולה ושמור על תמיכה מתועדת",
  "app.admin_workflows.delivery_failures": "מסירה כשלים",
  "app.admin_workflows.inspect_rollout_related_failures_publishing_health_and_processing_queues_before_escalating_to": "בדוק השקה קשור כשלים פרסום תקינות ו עיבוד תורים לפני הסקאלאטינג ל",
  "app.admin_workflows.moderation_queue": "ניהול תוכן תור",
  "app.admin_workflows.open_audit_review": "פתח ביקורת בדוק",
  "app.admin_workflows.open_moderation_queue": "פתח ניהול תוכן תור",
  "app.admin_workflows.open_ops_controls": "פתח תפעול בקרות",
  "app.admin_workflows.open_support_lookup": "פתח תמיכה חיפוש",
  "app.admin_workflows.operations_and_system_controls": "תפעול ו מערכת בקרות",
  "app.admin_workflows.permission_probe": "הרשאה בדיקה",
  "app.admin_workflows.principal_type": "ישות הרשאה סוג",
  "app.admin_workflows.processing_assets": "עיבוד נכסים",
  "app.admin_workflows.publishing_failures": "פרסום כשלים",
  "app.admin_workflows.review_guest_submitted_gallery_items_clear_pending_work_and_leave_an_auditable": "בדוק פריטי גלריה שנשלחו על ידי אורחים, נקה עבודה ממתינה והשאר תיעוד לביקורת",
  "app.admin_workflows.review_incidents": "בדוק אירועי מערכת",
  "app.admin_workflows.roles": "תפקידים",
  "app.admin_workflows.support_lookup_and_intervention_boundaries": "תמיכה חיפוש ו התערבות גבולות",
  "app.admin_workflows.users": "משתמשים",
  "app.admin_workflows.verify_the_role_catalog_inspect_recent_security_sensitive_changes_and_confirm_that": "אמת את קטלוג התפקידים, בדוק שינויים רגישים אחרונים ואשר שההרשאות תקינות",
  "app.admin_workflows.view_incidents": "תצוגה אירועי מערכת",
  "app.navigation.admin_home": "בית הניהול",
  "app.navigation.admin_intervention_history_with_traceability_by_admin_and_entity": "היסטוריית התערבויות ניהול עם עקיבות לפי מנהל וישות",
  "app.navigation.audit": "ביקורת",
  "app.navigation.audit_trails_permission_diagnostics_and_sensitive_action_review": "ביקורת יומנים הרשאה אבחון ו רגיש פעולה בדוק",
  "app.navigation.authenticated_admin_identity_and_current_authorization_proof": "מאומת ניהול זהות ו נוכחי הרשאה הוכחה",
  "app.navigation.backups": "גיבויים",
  "app.navigation.capabilities": "יכולות",
  "app.navigation.communication_templates": "תקשורת תבניות",
  "app.navigation.compact_internal_openapi_reference_for_admin_api_operations": "רפרנס OpenAPI פנימי ותמציתי לפעולות API של הניהול",
  "app.navigation.connection_health_scopes_and_partner_framework_support_visibility": "חיבור תקינות היקפים ו שותף מסגרת תמיכה נראות",
  "app.navigation.curated_operational_intelligence_service_status_and_grafana_drill_downs": "מודיעין תפעולי אצור, סטטוס שירותים וניתוחי Grafana",
  "app.navigation.current_platform_posture_admin_auth_status_and_support_entry_point": "נוכחי פלטפורמה מצב ניהול אימות סטטוס ו תמיכה רשומה נקודה",
  "app.navigation.directory": "ספרייה",
  "app.navigation.escalation_focused_failures_across_moderation_delivery_and_publishing": "הסלמה ממוקד כשלים ברחבי ניהול תוכן מסירה ו פרסום",
  "app.navigation.events": "אירועים",
  "app.navigation.feature_flags": "תכונה דגלים",
  "app.navigation.identity_service": "זהות שירות",
  "app.navigation.incidents": "אירועי מערכת",
  "app.navigation.inspect_final_capability_resolution_source_precedence_and_anomalies": "בדוק סופי יכולת פתרון מקור קדימות ו חריגות",
  "app.navigation.internal_docs": "פנימי מסמכים",
  "app.navigation.internal_motion_prototyping_surfaces_for_animation_timing_depth_and_choreography": "משטחי אב-טיפוס פנימיים בתנועה לתזמון אנימציה לעומק ולכוריאוגרפיה",
  "app.navigation.interventions": "התערבויות",
  "app.navigation.keycloak_backed_identity_settings_and_public_access_controls": "הגדרות זהות מבוססות Keycloak ובקרות גישה ציבורית",
  "app.navigation.knowledge": "ידע",
  "app.navigation.manage_draft_and_published_communication_templates": "נהל תבניות תקשורת בטיוטה ובפרסום",
  "app.navigation.manage_outbound_webhook_subscriptions_events_and_delivery_status": "נהל מנויי Webhook יוצאים, אירועים וסטטוס מסירה",
  "app.navigation.management": "ניהול",
  "app.navigation.messaging_providers_senders_and_country_routing_rules": "הודעות ספקי שירות שולחים ו מדינה ניתוב חוקים",
  "app.navigation.messaging_service": "הודעות שירות",
  "app.navigation.moderation": "ניהול תוכן",
  "app.navigation.operations": "תפעול",
  "app.navigation.operations_console": "תפעול מסוף",
  "app.navigation.plans_subscriptions_entitlement_posture_and_payment_state_support": "מסלולים מנויים זכאות מצב ו תשלום מצב תמיכה",
  "app.navigation.platform_operations_publishing_failures_and_system_controls": "פלטפורמה תפעול פרסום כשלים ו מערכת בקרות",
  "app.navigation.playgrounds": "מגרשי משחקים",
  "app.navigation.recovery_manifests_retention_posture_and_backup_visibility": "שחזור מניפסטים שמירה מצב ו גיבוי נראות",
  "app.navigation.repository_setup_runbooks_and_platform_reference_entry_point": "מאגר הגדרה נהלים ו פלטפורמה הפניה רשומה נקודה",
  "app.navigation.review_gallery_submissions_and_clear_pending_moderation_work": "בדוק הגשות גלריה ונקה עבודת מודרציה ממתינה",
  "app.navigation.rollout": "השקה",
  "app.navigation.rollout_targeting_kill_switches_and_preview_visibility_controls": "השקה מיקוד השבתה מתגים ו תצוגה מקדימה נראות בקרות",
  "app.navigation.search_and_inspect_platform_wide_users_and_occasions_with_paginated_views": "חיפוש ו בדוק פלטפורמה וידה משתמשים ו אירועים עם פאגינאטהד ויהוס",
  "app.navigation.search_platform_records_inspect_state_and_run_bounded_support_actions": "חיפוש פלטפורמה רהקורדס בדוק מצב ו הרץ מוגבל תמיכה פעולות",
  "app.navigation.security": "אבטחה",
  "app.navigation.services": "שירותים",
  "app.navigation.shared_ui_component_catalog_and_interactive_development_surface": "קטלוג רכיבי UI משותפים וממשק פיתוח אינטראקטיבי",
  "app.navigation.swagger": "Swagger",
  "app.navigation.webhooks": "וובהוקים",
  "app.router.app_router_return_to_admin_home": "חזור לבית הניהול",
  "app.search.status": "סטטוס",
  "components.app_shell.components_app_shell_admin_app_installed": "אפליקציית הניהול הותקנה",
  "components.app_shell.components_app_shell_admin_sections": "מקטעי ניהול",
  "components.app_shell.components_app_shell_choose_add_to_home_screen_for_the_admin_console": "בחר הוסף ל בית מסך עבור ניהול מסוף",
  "components.app_shell.components_app_shell_install_the_admin_console_for_faster_platform_operations_access": "התקן ניהול מסוף עבור פאסטהר פלטפורמה תפעול גישה",
  "components.app_shell.components_app_shell_installing_admin_app": "מתקין את אפליקציית הניהול",
  "components.app_shell.components_app_shell_keep_admin_operations_available_from_your_home_screen": "שמור את תפעול הניהול זמין ממסך הבית",
  "components.app_shell.components_app_shell_save_the_admin_console_from_safari_to_keep_it_one_tap_away": "שמור את מסוף הניהול מ-Safari כדי להשאיר אותו במרחק הקשה אחת",
  "components.app_shell.install_admin_app": "התקן את אפליקציית הניהול",
  "content.internal_docs_content.api_implementation_notes": "הערות יישום API",
  "content.internal_docs_content.complete_internal_http_contract_including_admin_and_platform_only_routes": "חוזה HTTP פנימי מלא כולל נתיבי ניהול ופלטפורמה בלבד",
  "content.internal_docs_content.core_model_capability_packaging_state_machines_admin_console_and_platform_runtime_docs": "קורה מודהל יכולת פאקאגינג מצב מאצ׳ינהס ניהול מסוף ו פלטפורמה זמן ריצה מסמכים",
  "content.internal_docs_content.engineer_facing_setup_and_repository_material_that_should_stay_out_of_the": "חומרי הגדרה ומאגר למהנדסים שצריכים להישאר מחוץ לתיעוד הציבורי",
  "content.internal_docs_content.full_internal_swagger_and_platform_facing_reference_material_for_planners_admins_operations": "Swagger פנימי מלא וחומרי רפרנס לפלטפורמה עבור מתכננים, מנהלים ותפעול",
  "content.internal_docs_content.full_openapi_contract": "חוזה OpenAPI מלא",
  "content.internal_docs_content.internal_analytics_privacy_and_sentry_oriented_operational_guidance": "הנחיות תפעול פנימיות לאנליטיקה, פרטיות ו-Sentry",
  "content.internal_docs_content.internal_api_contracts": "חוזי API פנימיים",
  "content.internal_docs_content.internal_api_design_implementation_notes_and_versioning_decisions": "עיצוב API פנימי, הערות יישום והחלטות גרסאות",
  "content.internal_docs_content.internal_architecture_operations_backup_observability_and_rollout_material_for_platform_teams": "פנימי ארכיטקטורה תפעול גיבוי תצפיתיות ו השקה חומר עבור פלטפורמה טהאמס",
  "content.internal_docs_content.internal_ci_quality_and_testing_conventions_for_the_monorepo": "מוסכמות CI, איכות ובדיקות פנימיות למונורפו",
  "content.internal_docs_content.launch_readiness_hardening_incident_posture_and_dependency_degradation_runbooks": "נהלי מוכנות השקה, הקשחה, מצב אירועים וירידת תלויות",
  "content.internal_docs_content.local_and_repository_documentation": "מקומי ו מאגר תיעוד",
  "content.internal_docs_content.local_architecture_and_runbooks_for_development_environments": "מקומי ארכיטקטורה ו נהלים עבור פיתוח הנוירונמהנטס",
  "content.internal_docs_content.local_services": "מקומי שירותים",
  "content.internal_docs_content.machine_readable_outbound_webhook_catalog_used_by_the_platform": "קטלוג Webhook יוצא וקריא למכונה המשמש את הפלטפורמה",
  "content.internal_docs_content.observability_references": "תצפיתיות רהפהרהנקהס",
  "content.internal_docs_content.operations_runbooks": "תפעול נהלים",
  "content.internal_docs_content.platform_and_operations_docs": "פלטפורמה ו תפעול מסמכים",
  "content.internal_docs_content.platform_internals": "פנימיות הפלטפורמה",
  "content.internal_docs_content.repository_setup": "מאגר הגדרה",
  "content.internal_docs_content.tooling_and_testing": "טולינג ו בדיקות",
  "content.internal_docs_content.webhook_contract": "חוזה Webhook",
  "content.internal_docs_content.workspace_setup_bootstrap_decisions_and_repository_structure_notes": "הגדרת סביבת עבודה, החלטות אתחול והערות מבנה מאגר",
  "contexts.session_context.your_account_does_not_have_platform_administrator_access": "שלך חשבון דוהס לא יש פלטפורמה מנהל גישה",
  "features.monitoring.api.grafana.degraded_message": "ירוד הודעה",
  "features.monitoring.api.grafana.health_returned": "תקינות רהטורנהד",
  "features.monitoring.api.grafana.reachable_message": "נגיש הודעה",
  "features.monitoring.api.grafana.unreachable_message": "לא נגיש הודעה",
  "features.monitoring.api.health.active_incidents_summary": "פעיל אירועי מערכת סיכום",
  "features.monitoring.api.health.api_server": "שרת API",
  "features.monitoring.api.health.api_server_summary": "סיכום שרת API",
  "features.monitoring.api.health.backups_summary": "גיבויים סיכום",
  "features.monitoring.api.health.communications_delivery_incident": "תקשורת מסירה אירוע מערכת",
  "features.monitoring.api.health.communications_detail": "תקשורת פרט",
  "features.monitoring.api.health.communications_summary": "תקשורת סיכום",
  "features.monitoring.api.health.consistency_violations_detected": "קונסיסטהנקי ויולאטיונס דהטהקטהד",
  "features.monitoring.api.health.critical_consistency_incident": "קריטי עקביות אירוע מערכת",
  "features.monitoring.api.health.critical_invariants_remain_unresolved": "אינווריאנטים קריטיים עדיין לא נפתרו",
  "features.monitoring.api.health.database_detail": "מסד נתונים פרט",
  "features.monitoring.api.health.database_summary": "מסד נתונים סיכום",
  "features.monitoring.api.health.database_visibility": "מסד נתונים נראות",
  "features.monitoring.api.health.delivery_failures_are_active": "מסירה כשלים הם פעיל",
  "features.monitoring.api.health.heartbeat": "דופק",
  "features.monitoring.api.health.inspect_failed_deliveries_before_retrying_provider_sends": "בדוק נכשל מסירות לפני רהטריינג ספק שירות סהנדס",
  "features.monitoring.api.health.invariant_violations_require_investigation": "אינווריאנט ויולאטיונס רהקוירה ינוהסטיגאטיונ",
  "features.monitoring.api.health.last_error": "אחרון שגיאה",
  "features.monitoring.api.health.no_active_incidents_summary": "אין פעיל אירועי מערכת סיכום",
  "features.monitoring.api.health.no_timestamp_available": "אין טימהסטאמפ זמין",
  "features.monitoring.api.health.platform_engineering": "פלטפורמה מהנדסיםינג",
  "features.monitoring.api.health.publishing_degradation": "פרסום ירידה",
  "features.monitoring.api.health.publishing_detail": "פרסום פרט",
  "features.monitoring.api.health.publishing_jobs_failed_and_may_block_rollout_activity": "פרסום עבודות נכשל ו עשוי בלוק השקה פעילות",
  "features.monitoring.api.health.publishing_summary": "פרסום סיכום",
  "features.monitoring.api.health.release_management": "שחרור ניהול",
  "features.monitoring.api.health.review_invariant_evidence_and_reconcile_affected_resources_before_reopening_workflows": "בדוק ראיות אינווריאנטים והתאם משאבים מושפעים לפני פתיחה מחדש של תהליכי עבודה",
  "features.monitoring.api.health.validate_rollout_health_before_resuming_publish_operations": "אמת השקה תקינות לפני רהסומינג פרסם תפעול",
  "features.monitoring.api.health.worker_fleet": "צי Workers",
  "features.monitoring.api.health.worker_fleet_summary": "סיכום צי Workers",
  "features.monitoring.api.metrics.active_traces": "פעיל עקבות",
  "features.monitoring.api.metrics.active_traces_helper": "פעיל עקבות עזרה",
  "features.monitoring.api.metrics.critical_invariant_violations": "קריטי אינווריאנט הפרות",
  "features.monitoring.api.metrics.dead_letter_jobs": "מת מכתב עבודות",
  "features.monitoring.api.metrics.dead_letter_jobs_helper": "דהאד להטטהר עבודות עזרה",
  "features.monitoring.api.metrics.delivery_failures_helper": "מסירה כשלים עזרה",
  "features.monitoring.api.metrics.errors_across_requests": "שגיאות ברחבי בקשות",
  "features.monitoring.api.metrics.guest_rsvp_completion": "השלמת RSVP של אורחים",
  "features.monitoring.api.metrics.planner_activity": "מתכנן פעילות",
  "features.monitoring.api.metrics.planner_activity_helper": "מתכנן פעילות עזרה",
  "features.monitoring.api.metrics.processing_assets_helper": "עיבוד נכסים עזרה",
  "features.monitoring.api.metrics.publishing_failures_helper": "פרסום כשלים עזרה",
  "features.monitoring.api.metrics.queued_jobs": "בתור עבודות",
  "features.monitoring.api.metrics.queued_jobs_helper": "בתור עבודות עזרה",
  "features.monitoring.api.metrics.retry_jobs": "נסה שוב עבודות",
  "features.monitoring.api.metrics.retry_jobs_helper": "נסה שוב עבודות עזרה",
  "features.monitoring.api.metrics.server_errors": "שרת שגיאות",
  "features.monitoring.api.metrics.tracked_guests": "במעקב אורחים",
  "features.monitoring.api.metrics.tracked_guests_helper": "עזרה לאורחים במעקב",
  "features.monitoring.api.metrics.triggered_alerts": "טריגגהרהד התראות",
  "features.monitoring.api.metrics.worker_queue_depth": "עומק תור Workers",
  "features.monitoring.components.active_connections_chart.active_connections_and_sessions": "פעיל חיבורים ו סהססיונס",
  "features.monitoring.components.alert_feed.curated_alert_feed": "פיד התראות אצור",
  "features.monitoring.components.alert_feed.no_alerts_are_active": "אין התראות הם פעיל",
  "features.monitoring.components.dashboard_embed.add_a_grafana_url_to_enable_embedded_monitoring_drill_downs": "הוסף URL של Grafana כדי לאפשר ניתוחי ניטור מוטמעים",
  "features.monitoring.components.dashboard_embed.grafana": "Grafana",
  "features.monitoring.components.error_rate_chart.error_rate_snapshot": "שגיאה שיעור תמונת מצב",
  "features.monitoring.components.health_status_card.service": "שירות",
  "features.monitoring.components.incident_banner.open_incidents": "פתח אירועי מערכת",
  "features.monitoring.components.log_viewer.message_code_request_id_or_correlation_id": "קוד הודעה, Request ID או Correlation ID",
  "features.monitoring.components.log_viewer.no_request_context": "אין בקשה הקשר",
  "features.monitoring.components.log_viewer.open_in_grafana": "פתח ב-Grafana",
  "features.monitoring.components.log_viewer.operational_log_search": "תפעולי לוג חיפוש",
  "features.monitoring.components.log_viewer.search_logs": "חיפוש לוגים",
  "features.monitoring.components.queue_depth_chart.queues": "תורים",
  "features.monitoring.components.request_latency_chart.request_latency": "בקשה השהיה",
  "features.monitoring.components.trace_viewer.duration_unavailable": "משך לא זמינות",
  "features.monitoring.components.trace_viewer.no_traces_match_the_current_filters": "אין עקבות מאטצ׳ נוכחי מסננים",
  "features.monitoring.components.trace_viewer.search_traces": "חיפוש עקבות",
  "features.monitoring.components.trace_viewer.trace_id_event_type_or_principal_type": "Trace ID, סוג אירוע או סוג ישות הרשאה",
  "features.monitoring.components.trace_viewer.trace_inspection": "עקבה בדיקה",
  "features.monitoring.components.trace_viewer.unknown_principal": "לא ידוע ישות הרשאה",
  "features.monitoring.navigation.database": "מסד נתונים",
  "features.monitoring.navigation.infrastructure": "תשתית",
  "features.monitoring.navigation.logs": "לוגים",
  "features.monitoring.navigation.traces": "עקבות",
  "features.monitoring.navigation.workers": "עובדים",
  "features.monitoring.pages.alerts_page.alert_management": "התראה ניהול",
  "features.monitoring.pages.alerts_page.alerts_and_escalations": "התראות ו הסקאלאטיונס",
  "features.monitoring.pages.alerts_page.keep_platform_alerting_inside_the_admin_control_surface_with_grafana_as_the_backend": "השאר התראות פלטפורמה בתוך ממשק בקרת הניהול עם Grafana כבקאנד",
  "features.monitoring.pages.database_page.database_operations": "מסד נתונים תפעול",
  "features.monitoring.pages.database_page.keep_postgres_health_and_operational_database_visibility_inside_the_admin_control": "השאר תקינות Postgres ונראות מסד נתונים תפעולית בתוך בקרת הניהול",
  "features.monitoring.pages.database_page.postgres_visibility_and_health": "נראות ותקינות Postgres",
  "features.monitoring.pages.incidents_page.curated_incident_visibility": "אצור אירוע מערכת נראות",
  "features.monitoring.pages.incidents_page.focus_the_admin_surface_on_active_incidents_instead_of_raw_telemetry": "מיקוד ניהול ממשק על פעיל אירועי מערכת ינסטהאד של גולמי טלמטריה",
  "features.monitoring.pages.incidents_page.incident_response": "אירוע מערכת תגובה",
  "features.monitoring.pages.infrastructure_page.combine_datasource_status_queue_posture_and_shared_service_health_into_one_internal": "שלב סטטוס מקור נתונים, מצב תורים ותקינות שירותים משותפים לתצוגה פנימית אחת",
  "features.monitoring.pages.infrastructure_page.infrastructure_posture": "מצב תשתית",
  "features.monitoring.pages.infrastructure_page.internal_infrastructure_status": "פנימי תשתית סטטוס",
  "features.monitoring.pages.logs_page.operational_log_visibility": "תפעולי לוג נראות",
  "features.monitoring.pages.logs_page.search_application_errors_without_leaving_the_internal_admin_surface": "חיפוש אפליקציה שגיאות ללא לעזוב פנימי ניהול ממשק",
  "features.monitoring.pages.monitoring_overview_page.admin_platform_control_center": "ניהול פלטפורמה בקרה מרכז",
  "features.monitoring.pages.monitoring_overview_page.executive_summary": "מנהלים סיכום",
  "features.monitoring.pages.monitoring_overview_page.monitoring_sections": "ניטור מקטעים",
  "features.monitoring.pages.monitoring_overview_page.operational_intelligence": "תפעולי מודיעין",
  "features.monitoring.pages.monitoring_overview_page.turn_grafana_prometheus_loki_tempo_and_application_telemetry_into_a_curated": "הפוך את Grafana, Prometheus, Loki, Tempo וטלמטריית האפליקציה לתצוגה אצורה",
  "features.monitoring.pages.services_page.platform_service_status_visibility": "פלטפורמה שירות סטטוס נראות",
  "features.monitoring.pages.services_page.review_curated_service_status_before_drilling_into_grafana_for_raw_telemetry": "בדוק סטטוס שירותים אצור לפני מעבר ל-Grafana לטלמטריה גולמית",
  "features.monitoring.pages.services_page.service_health": "שירות תקינות",
  "features.monitoring.pages.traces_page.inspect_platform_request_flows_and_operational_trace_context_inside_the_admin": "בדוק פלטפורמה בקשה זרימות ו תפעולי עקבה הקשר בתוך ניהול",
  "features.monitoring.pages.traces_page.trace_inspection_and_latency": "עקבה בדיקה ו השהיה",
  "features.monitoring.pages.traces_page.trace_monitoring": "עקבה ניטור",
  "features.monitoring.pages.workers_page.keep_background_processing_operational_without_leaving_the_admin_platform": "שמור עיבוד רקע תפעולי בלי לעזוב את פלטפורמת הניהול",
  "features.monitoring.pages.workers_page.queue_and_worker_visibility": "נראות תורים ו-Workers",
  "features.monitoring.pages.workers_page.worker_operations": "תפעול Workers",
  "features.monitoring.resource.load_failed": "לא ניתן לטעון את משאב הניטור.",
  "features.monitoring.status.critical": "קריטי",
  "features.monitoring.status.degraded": "ירוד",
  "features.monitoring.status.healthy": "תקין",
  "pages.audit_page.event_kind": "אירוע קינד",
  "pages.audit_page.no_matching_audit_filters": "לא נמצאו מסנני ביקורת תואמים.",
  "pages.audit_page.occasion_scope": " בחגיגה {occasion}",
  "pages.audit_page.pages_audit_page_at": "אט",
  "pages.audit_page.pages_audit_page_defined_roles": "דהפינהד תפקידים",
  "pages.audit_page.pages_audit_page_grants": "הענקות",
  "pages.audit_page.pages_audit_page_intervention": "התערבות",
  "pages.audit_page.pages_audit_page_platform_audit_and_activity": "פלטפורמה ביקורת ו פעילות",
  "pages.audit_page.pages_audit_page_recent_changes": "אחרון שינויים",
  "pages.audit_page.pages_audit_page_request_id": "זיהוי בקשה",
  "pages.audit_page.pages_audit_page_role_catalog": "תפקיד קטלוג",
  "pages.audit_page.the_admin_audit_surface_could_not_load_platform_activity": "ניהול ביקורת ממשק יכול לא לואד פלטפורמה פעילות",
  "pages.audit_page.value_absent": "הערך לא תועד",
  "pages.audit_page.value_after": "אחרי",
  "pages.audit_page.value_before": "לפני",
  "pages.audit_page.value_redacted": "[מוסתר]",
  "pages.backups_page.backup_manifest_queue_failed": "גיבוי מניפסט תור נכשל",
  "pages.backups_page.backup_manifest_queued": "גיבוי מניפסט בתור",
  "pages.backups_page.pages_backups_page_asset_references": "נכס רהפהרהנקהס",
  "pages.backups_page.pages_backups_page_assets_mode": "נכסים מצב",
  "pages.backups_page.pages_backups_page_database_mode": "מסד נתונים מצב",
  "pages.backups_page.pages_backups_page_download_manifest": "הורד מניפסט",
  "pages.backups_page.pages_backups_page_exports": "ייצואים",
  "pages.backups_page.pages_backups_page_generated_artifacts": "שנוצר ארטיפקטים",
  "pages.backups_page.pages_backups_page_imports": "ייבואים",
  "pages.backups_page.pages_backups_page_operator_action": "מפעיל פעולה",
  "pages.backups_page.pages_backups_page_platform_recovery_seam": "פלטפורמה שחזור נקודת חיבור",
  "pages.backups_page.pages_backups_page_queue_backup_manifest": "תור גיבוי מניפסט",
  "pages.backups_page.pages_backups_page_queue_recovery_manifest": "תור שחזור מניפסט",
  "pages.backups_page.pages_backups_page_recent_manifests": "אחרון מניפסטים",
  "pages.backups_page.pages_backups_page_recovery_manifests_inventory_generated_artifacts_and_current_data": "שחזור מניפסטים מלאי שנוצר ארטיפקטים ו נוכחי דאטא",
  "pages.backups_page.pages_backups_page_retention_days": "שמירה ימים",
  "pages.backups_page.the_backup_overview_could_not_be_loaded": "גיבוי סקירה יכול לא להיות נטען",
  "pages.billing_page.agency_account": "חשבון סוכנות",
  "pages.billing_page.billing_product_key": "מפתח מוצר חיוב",
  "pages.billing_page.create_next_version": "צור את הגרסה הבאה",
  "pages.billing_page.description": "תיאור",
  "pages.billing_page.display_name": "שם תצוגה",
  "pages.billing_page.edit_version": "ערוך גרסה",
  "pages.billing_page.entitlements_json": "זכויות JSON",
  "pages.billing_page.entitlements_must_be_array": "הזכויות חייבות להיות מערך",
  "pages.billing_page.family_key": "מפתח משפחתי",
  "pages.billing_page.internal_version": "גרסה פנימית",
  "pages.billing_page.latest_public_for_family": "הציבור האחרון למשפחה",
  "pages.billing_page.latest_public_version": "הגרסה הציבורית האחרונה",
  "pages.billing_page.manage_plan_version": "נהל את גרסת התוכנית",
  "pages.billing_page.metadata_json": "מטא נתונים JSON",
  "pages.billing_page.monthly_price_minor": "מחיר חודשי מינור",
  "pages.billing_page.pages_billing_page_accounts": "חשבונות",
  "pages.billing_page.pages_billing_page_active_subscriptions": "פעיל מנויים",
  "pages.billing_page.pages_billing_page_applied_packages": "מיושם חבילות",
  "pages.billing_page.pages_billing_page_billing_accounts": "חיוב חשבונות",
  "pages.billing_page.pages_billing_page_missing": "חסר",
  "pages.billing_page.pages_billing_page_no_plan": "אין מסלול",
  "pages.billing_page.pages_billing_page_past_due": "עבר לתשלום",
  "pages.billing_page.pages_billing_page_platform_subscriptions_and_entitlement_state": "פלטפורמה מנויים ו זכאות מצב",
  "pages.billing_page.pages_billing_page_program_id": "מזהה תוכנית",
  "pages.billing_page.pages_billing_page_referral_configuration": "הפניה תצורה",
  "pages.billing_page.pages_billing_page_unowned_account": "ללא בעלים חשבון",
  "pages.billing_page.plan_families": "לתכנן משפחות",
  "pages.billing_page.plan_key": "מפתח תוכנית",
  "pages.billing_page.plan_version_save_failed": "שמירת גרסת התוכנית נכשלה",
  "pages.billing_page.plan_version_saved": "גרסת התוכנית נשמרה",
  "pages.billing_page.plan_versions": "גרסאות תוכנית",
  "pages.billing_page.planner_dashboard": "לוח מחוונים של מתכנן",
  "pages.billing_page.product_surface": "משטח המוצר",
  "pages.billing_page.publicly_selectable": "ניתן לבחירה באופן ציבורי",
  "pages.billing_page.save_plan_version": "שמור את גרסת התוכנית",
  "pages.billing_page.saving_plan_version": "גירסת תוכנית שמירת",
  "pages.billing_page.sort_order": "סדר מיון",
  "pages.billing_page.status": "סטטוס",
  "pages.billing_page.subscribers": "מנויים",
  "pages.billing_page.the_admin_billing_surface_could_not_be_loaded": "ניהול חיוב ממשק יכול לא להיות נטען",
  "pages.billing_page.vendor_workspace": "סביבת עבודה של ספק",
  "pages.billing_page.version": "גִרְסָה",
  "pages.billing_page.versions": "גרסאות",
  "pages.billing_page.yearly_price_minor": "מחיר שנתי מינור",
  "pages.capability_debug_page.capability_debug_inspection_failed": "יכולת דיבוג בדיקה נכשל",
  "pages.capability_debug_page.pages_capability_debug_page_anomalies": "חריגות",
  "pages.capability_debug_page.pages_capability_debug_page_billing_account_id_override": "עקיפת Billing Account ID",
  "pages.capability_debug_page.pages_capability_debug_page_capability_debug": "יכולת דיבוג",
  "pages.capability_debug_page.pages_capability_debug_page_capability_explanations": "יכולת הקסמתכנןאטיונס",
  "pages.capability_debug_page.pages_capability_debug_page_evaluated_grants": "הוערך הענקות",
  "pages.capability_debug_page.pages_capability_debug_page_inspect_capability_resolution": "בדוק יכולת פתרון",
  "pages.capability_debug_page.pages_capability_debug_page_inspection_error": "בדיקה שגיאה",
  "pages.capability_debug_page.pages_capability_debug_page_leave_empty_to_inspect_the_current_admin_account": "השאר ריק ל בדוק נוכחי ניהול חשבון",
  "pages.capability_debug_page.pages_capability_debug_page_no_anomalies": "אין חריגות",
  "pages.capability_debug_page.pages_capability_debug_page_no_enabled_capabilities": "אין מופעל יכולות",
  "pages.capability_debug_page.pages_capability_debug_page_no_override": "אין עקיפה",
  "pages.capability_debug_page.pages_capability_debug_page_no_source_key": "אין מקור מפתח",
  "pages.capability_debug_page.pages_capability_debug_page_no_sources": "אין מקורות",
  "pages.capability_debug_page.pages_capability_debug_page_override": "עקיפה",
  "pages.capability_debug_page.pages_capability_debug_page_recent_resolution_logs": "אחרונים פתרון לוגים",
  "pages.capability_debug_page.pages_capability_debug_page_snapshot_summary": "תמונת מצב סיכום",
  "pages.capability_debug_page.pages_capability_debug_page_source_counts": "מקור ספירות",
  "pages.capability_debug_page.pages_capability_debug_page_the_current_snapshot_resolved_without_conflict_or_stale": "נוכחי תמונת מצב רהסולוהד ללא התנגשות או מיושן",
  "pages.capability_debug_page.pages_capability_debug_page_unresolved": "לא פתור",
  "pages.capability_debug_page.pages_capability_debug_page_winner": "זוכה",
  "pages.capability_debug_page.the_capability_debug_snapshot_could_not_be_loaded": "יכולת דיבוג תמונת מצב יכול לא להיות נטען",
  "pages.communication_templates.body": "גוף",
  "pages.communication_templates.configure_template_copy_status_and_scope": "הגדר תבנית העתק סטטוס ו היקף",
  "pages.communication_templates.create_template": "צור תבנית",
  "pages.communication_templates.edit_template": "ערוך תבנית",
  "pages.communication_templates.move_to_draft": "העבר ל טיוטה",
  "pages.communication_templates.no_matching_template_filters": "אין תואם תבנית מסננים",
  "pages.communication_templates.no_subject": "אין נושא",
  "pages.communication_templates.occasion_id": "מזהה אירוע",
  "pages.communication_templates.platform": "פלטפורמה",
  "pages.communication_templates.publish": "פרסם",
  "pages.communication_templates.scope": "תחום",
  "pages.communication_templates.selected_template": "נבחר תבנית",
  "pages.communication_templates.subject": "נושא",
  "pages.communication_templates.template_key": "תבנית מפתח",
  "pages.communication_templates.template_save_failed": "תבנית שמור נכשל",
  "pages.communication_templates.template_saved": "תבנית נשמר",
  "pages.communication_templates.template_status_updated": "תבנית סטטוס עודכן",
  "pages.communication_templates.templates": "תבניות",
  "pages.communication_templates.templates_could_not_be_loaded": "תבניות יכול לא להיות נטען",
  "pages.docs_page.changelog_source": "מקור יומן שינויים",
  "pages.docs_page.current_frontend_version": "גרסת חזית נוכחית",
  "pages.docs_page.docs_page_access_mode": "מסמכים עמוד גישה מצב",
  "pages.docs_page.docs_page_all_methods": "מסמכים עמוד כל שיטות",
  "pages.docs_page.docs_page_all_tags": "מסמכים עמוד כל טאגס",
  "pages.docs_page.docs_page_audience_guests": "מסמכים עמוד קהל אורחים",
  "pages.docs_page.docs_page_audience_integrations": "קהל אינטגרציות",
  "pages.docs_page.docs_page_audience_partners_and_external_integrations": "קהל שותפים ואינטגרציות חיצוניות",
  "pages.docs_page.docs_page_audience_planners_and_internal_operators": "מסמכים עמוד קהל מתכננים ו פנימי ופהראטורס",
  "pages.docs_page.docs_page_audience_platform_admins": "מסמכים עמוד קהל פלטפורמה מנהלים",
  "pages.docs_page.docs_page_auth_and_access": "מסמכים עמוד אימות ו גישה",
  "pages.docs_page.docs_page_copy_curl": "מסמכים עמוד העתק קורל",
  "pages.docs_page.docs_page_copy_failed": "מסמכים עמוד העתק נכשל",
  "pages.docs_page.docs_page_copy_failed_try_manual_copy": "מסמכים עמוד העתק נכשל טרי מאנואל העתק",
  "pages.docs_page.docs_page_curl_copied": "מסמכים עמוד קורל הועתק",
  "pages.docs_page.docs_page_domain_owner": "מסמכים עמוד דומאינ בעלים",
  "pages.docs_page.docs_page_example_request": "מסמכים עמוד הקסאמפלה בקשה",
  "pages.docs_page.docs_page_feature_flags": "מסמכים עמוד תכונה דגלים",
  "pages.docs_page.docs_page_filter_by_method": "מסמכים עמוד סינון לפי שיטה",
  "pages.docs_page.docs_page_filter_by_tag": "מסמכים עמוד סינון לפי טאג",
  "pages.docs_page.docs_page_filter_help": "מסמכים עמוד סינון עזרה",
  "pages.docs_page.docs_page_group_general": "כללי",
  "pages.docs_page.docs_page_matching_operations": "מסמכים עמוד תואם תפעול",
  "pages.docs_page.docs_page_no_feature_flags_declared": "מסמכים עמוד אין תכונה דגלים דהקלארהד",
  "pages.docs_page.docs_page_no_matching_operations": "מסמכים עמוד אין תואם תפעול",
  "pages.docs_page.docs_page_no_matching_operations_help": "מסמכים עמוד אין תואם תפעול עזרה",
  "pages.docs_page.docs_page_no_parameters": "מסמכים עמוד אין פרמטרים",
  "pages.docs_page.docs_page_no_request_example": "מסמכים עמוד אין בקשה הקסאמפלה",
  "pages.docs_page.docs_page_no_response_body": "מסמכים עמוד אין תגובה גוף",
  "pages.docs_page.docs_page_no_response_description": "מסמכים עמוד אין תגובה",
  "pages.docs_page.docs_page_optional_parameter": "מסמכים עמוד אופציונלי פרמטר",
  "pages.docs_page.docs_page_owner_platform": "פלטפורמה",
  "pages.docs_page.docs_page_primary_audience": "מסמכים עמוד פרימארי קהל",
  "pages.docs_page.docs_page_request_body_optional": "מסמכים עמוד בקשה גוף אופציונלי",
  "pages.docs_page.docs_page_request_body_required": "מסמכים עמוד בקשה גוף נדרש",
  "pages.docs_page.docs_page_request_details": "מסמכים עמוד בקש פרטים",
  "pages.docs_page.docs_page_required_parameter": "מסמכים עמוד נדרש פרמטר",
  "pages.docs_page.docs_page_response_details": "מסמכים עמוד תגובה פרטים",
  "pages.docs_page.docs_page_search_operations": "מסמכים עמוד חיפוש תפעול",
  "pages.docs_page.docs_page_search_placeholder": "מסמכים עמוד חיפוש פלאקההולדהר",
  "pages.docs_page.docs_page_security_summary_authenticated_admin_session": "מסמכים עמוד אבטחה סיכום מאומת ניהול הפעלה",
  "pages.docs_page.docs_page_security_summary_authenticated_session": "מסמכים עמוד אבטחה סיכום מאומת הפעלה",
  "pages.docs_page.docs_page_security_summary_guest_flow_access": "מסמכים עמוד אבטחה סיכום אורח תהליך גישה",
  "pages.docs_page.docs_page_security_summary_guest_token_access": "מסמכים עמוד אבטחה סיכום אורח אסימון גישה",
  "pages.docs_page.docs_page_security_summary_internal_platform_access": "מסמכים עמוד אבטחה סיכום פנימי פלטפורמה גישה",
  "pages.docs_page.docs_page_security_summary_no_authentication_required": "מסמכים עמוד אבטחה סיכום אין אותהנטיקאטיונ נדרש",
  "pages.docs_page.docs_page_security_summary_outbound_webhook_payload": "סיכום אבטחה למטען Webhook יוצא",
  "pages.docs_page.docs_page_security_summary_public_integration_surface": "מסמכים עמוד אבטחה סיכום ציבורי אינטגרציה ממשק",
  "pages.docs_page.docs_page_visibility": "מסמכים עמוד נראות",
  "pages.docs_page.docs_page_visibility_admin_only": "מסמכים עמוד נראות ניהול בלבד",
  "pages.docs_page.docs_page_visibility_guest_facing": "מסמכים עמוד נראות אורח מול",
  "pages.docs_page.docs_page_visibility_internal_api": "נראות API פנימי",
  "pages.docs_page.docs_page_visibility_outbound_webhook_catalog": "נראות קטלוג Webhook יוצא",
  "pages.docs_page.docs_page_visibility_public_api": "נראות API ציבורי",
  "pages.docs_page.frontend_changelog": "יומן שינויי חזית",
  "pages.docs_page.frontend_release_track": "מסלול שחרור חזית",
  "pages.docs_page.pages_docs_page_admin_docs_surface": "ניהול מסמכים ממשק",
  "pages.docs_page.pages_docs_page_admin_owned_documentation_and_internal_source_of_truth": "תיעוד בבעלות הניהול ומקור אמת פנימי",
  "pages.docs_page.pages_docs_page_internal_api_contract": "חוזה API פנימי",
  "pages.docs_page.pages_docs_page_internal_reference_map": "פנימי הפניה מפה",
  "pages.docs_page.pages_docs_page_internal_swagger_admin_api_visibility_repo_setup_local": "Swagger פנימי, נראות API לניהול, הגדרת מאגר וסביבה מקומית",
  "pages.docs_page.pages_docs_page_open_public_docs": "פתח ציבורי מסמכים",
  "pages.docs_page.pages_docs_page_public_api_subset": "תת-קבוצה של API ציבורי",
  "pages.docs_page.pages_docs_page_public_docs_now_focus_on_customer_facing_product": "התיעוד הציבורי מתמקד כעת במוצר המיועד ללקוחות",
  "pages.docs_page.pages_docs_page_public_docs_site": "ציבורי מסמכים סיטה",
  "pages.docs_page.pages_docs_page_public_split": "ציבורי ספליט",
  "pages.docs_page.pages_docs_page_resources_swagger_openapi_yaml": "משאבים Swagger OpenAPI YAML",
  "pages.docs_page.pages_docs_page_resources_swagger_public_openapi_yaml": "משאבים Swagger Public OpenAPI YAML",
  "pages.docs_page.pages_docs_page_resources_swagger_webhooks_yaml": "משאבים Swagger Webhooks YAML",
  "pages.docs_page.pages_docs_page_source_of_truth": "מקור אמת",
  "pages.docs_page.public_docs_site_summary": "ציבורי מסמכים סיטה סיכום",
  "pages.docs_page.release_baseline": "שחרור קו בסיס",
  "pages.feature_flags_page.backend": "בקאנד",
  "pages.feature_flags_page.both": "בות",
  "pages.feature_flags_page.create_feature_flag": "צור תכונה דגל",
  "pages.feature_flags_page.create_flag": "צור דגל",
  "pages.feature_flags_page.creating": "קרהאטינג",
  "pages.feature_flags_page.default_enabled": "ברירת מחדל מופעל",
  "pages.feature_flags_page.exposure": "חשיפה",
  "pages.feature_flags_page.feature_flag": "תכונה דגל",
  "pages.feature_flags_page.feature_flag_evaluation_reason": "תכונה דגל הערכה סיבה",
  "pages.feature_flags_page.feature_flag_has_targeting": "תכונה דגל יש טארגהטינג",
  "pages.feature_flags_page.filter_evaluation_reasons": "סינון הערכה רהאסונס",
  "pages.feature_flags_page.filter_feature_flag_keys": "סינון תכונה דגל מפתחות",
  "pages.feature_flags_page.filter_targeting": "סינון מיקוד",
  "pages.feature_flags_page.frontend": "חזית",
  "pages.feature_flags_page.key": "מפתח",
  "pages.feature_flags_page.kill_switch": "השבתה מתג",
  "pages.feature_flags_page.no_matching_feature_flag_filters": "אין תואם תכונה דגל מסננים",
  "pages.feature_flags_page.pages_feature_flags_page_admin_only": "ניהול בלבד",
  "pages.feature_flags_page.pages_feature_flags_page_development": "פיתוח",
  "pages.feature_flags_page.pages_feature_flags_page_environments": "סביבות",
  "pages.feature_flags_page.pages_feature_flags_page_internal_only": "פנימי בלבד",
  "pages.feature_flags_page.pages_feature_flags_page_percentage_rollout": "פהרקהנטאגה השקה",
  "pages.feature_flags_page.pages_feature_flags_page_production": "מוצריונ",
  "pages.feature_flags_page.pages_feature_flags_page_recent_rollout_audit": "אחרון השקה ביקורת",
  "pages.feature_flags_page.pages_feature_flags_page_targeted_billing_account_ids": "Billing Account IDs ממוקדים",
  "pages.feature_flags_page.pages_feature_flags_page_targeted_occasion_ids": "Occasion IDs ממוקדים",
  "pages.feature_flags_page.pages_feature_flags_page_targeted_user_ids": "User IDs ממוקדים",
  "pages.feature_flags_page.pages_feature_flags_page_targeting": "מיקוד",
  "pages.feature_flags_page.pages_feature_flags_page_test": "בדיקה",
  "pages.feature_flags_page.pages_feature_flags_page_update_error": "עדכון שגיאה",
  "pages.feature_flags_page.the_feature_flag_control_surface_could_not_be_loaded": "תכונה דגל בקרה ממשק יכול לא להיות נטען",
  "pages.feature_flags_page.the_feature_flag_could_not_be_created": "תכונה דגל יכול לא להיות נוצר",
  "pages.feature_flags_page.the_feature_flag_could_not_be_updated": "תכונה דגל יכול לא להיות עודכן",
  "pages.home_page.pages_home_page_audited_controls": "מבוקרים בקרות",
  "pages.home_page.pages_home_page_blocked_workflows": "חסום תהליכי עבודה",
  "pages.home_page.pages_home_page_changes_stay_visible_and_audited": "השינויים נשארים גלויים ומבוקרים",
  "pages.home_page.pages_home_page_current_constraints": "נוכחי קונסטראינטס",
  "pages.home_page.pages_home_page_lookup_before_intervention": "חיפוש לפני התערבות",
  "pages.home_page.pages_home_page_planner_isolation": "מתכנן יסולאטיונ",
  "pages.home_page.pages_home_page_policy": "מדיניות",
  "pages.home_page.pages_home_page_separate_from_planner_routes": "נפרד מנתיבי המתכננים",
  "pages.home_page.pages_home_page_support_first_intervention": "תמיכה ראשון התערבות",
  "pages.incidents_page.pages_incidents_page_consistency_incidents": "עקביות אירועי מערכת",
  "pages.incidents_page.pages_incidents_page_escalation_focused_platform_signals": "אותות פלטפורמה ממוקדי הסלמה",
  "pages.incidents_page.pages_incidents_page_failure_summary": "כשל סיכום",
  "pages.incidents_page.pages_incidents_page_pending_moderation": "ממתין ניהול תוכן",
  "pages.incidents_page.pages_incidents_page_recent_audit_context": "אחרונים ביקורת הקשר",
  "pages.incidents_page.pages_incidents_page_recent_failed_deliveries": "אחרון נכשל מסירות",
  "pages.incidents_page.pages_incidents_page_this_view_narrows_the_broader_ops_surface_down": "זה תצוגה נאררווס ברואדהר תפעול ממשק דוונ",
  "pages.integrations_page.pages_integrations_page_adapter_definitions": "אדאפטהר דהפיניטיונס",
  "pages.integrations_page.pages_integrations_page_all_email_and_sms_delivery_routes_through_the_shared_communications_layer": "כל נתיבי מסירת הדוא״ל וה-SMS עוברים דרך שכבת התקשורת המשותפת",
  "pages.integrations_page.pages_integrations_page_allowed_actions": "מורשה פעולות",
  "pages.integrations_page.pages_integrations_page_email_sms_and_storage_setup_posture": "מצב הגדרת דוא״ל, SMS ואחסון",
  "pages.integrations_page.pages_integrations_page_email_sms_provider_setup": "הגדרת ספק דוא״ל ו-SMS",
  "pages.integrations_page.pages_integrations_page_failing_connections": "פאילינג חיבורים",
  "pages.integrations_page.pages_integrations_page_failure": "כשל",
  "pages.integrations_page.pages_integrations_page_health": "תקינות",
  "pages.integrations_page.pages_integrations_page_implemented": "מיושם",
  "pages.integrations_page.pages_integrations_page_integrations_operations": "אינטגרציות תפעול",
  "pages.integrations_page.pages_integrations_page_internal": "פנימי",
  "pages.integrations_page.pages_integrations_page_monitor_connected_partner_systems_across_the_platform": "מיחידהור קוננהקטהד שותף סיסטהמס ברחבי פלטפורמה",
  "pages.integrations_page.pages_integrations_page_platform_policy_is_centralized_communications_routing_only": "פלטפורמה מדיניות הוא קהנטראליזהד תקשורת ניתוב בלבד",
  "pages.integrations_page.pages_integrations_page_provider_policy": "ספק שירות מדיניות",
  "pages.integrations_page.pages_integrations_page_retry_pending": "נסה שוב ממתין",
  "pages.integrations_page.pages_integrations_page_set_storage_default_provider_to_r2_or_gcs": "הגדר אחסון ברירת מחדל ספק שירות ל ר2 או גקס",
  "pages.integrations_page.pages_integrations_page_setup": "הגדרה",
  "pages.integrations_page.pages_integrations_page_setup_guide": "הגדרה גוידה",
  "pages.integrations_page.pages_integrations_page_storage": "אחסון",
  "pages.integrations_page.pages_integrations_page_storage_provider_setup": "אחסון ספק שירות הגדרה",
  "pages.integrations_page.pages_integrations_page_success": "הצלחה",
  "pages.integrations_page.pages_integrations_page_system_provider_status": "מערכת ספק שירות סטטוס",
  "pages.integrations_page.pages_integrations_page_this_surface_is_for_support_and_platform_ops": "זה ממשק הוא עבור תמיכה ו פלטפורמה תפעול",
  "pages.integrations_page.pages_integrations_page_via": "ויא",
  "pages.integrations_page.the_integration_operations_view_could_not_be_loaded": "לא ניתן היה לטעון את תצוגת תפעול האינטגרציות",
  "pages.interventions_page.adjust_the_admin_or_target_entity_filters_to_inspect_a_different_slice": "התאם את מסנני המנהל או ישות היעד כדי לבדוק חתך אחר",
  "pages.interventions_page.no_platform_admin_interventions_have_been_recorded_yet": "אין פלטפורמה ניהול התערבויות יש היה רהקורדהד עדיין",
  "pages.interventions_page.pages_interventions_page_admin_intervention_history": "ניהול התערבות היסטוריה",
  "pages.interventions_page.pages_interventions_page_all_admin_interventions_are_recorded_as_system_principal": "כל ניהול התערבויות הם רהקורדהד בתור מערכת ישות הרשאה",
  "pages.interventions_page.pages_interventions_page_by": "לפי",
  "pages.interventions_page.pages_interventions_page_distinct_admins": "דיסטינקט מנהלים",
  "pages.interventions_page.pages_interventions_page_distinct_entities": "ישויות מובחנות",
  "pages.interventions_page.pages_interventions_page_e_g_gallery_item_abc123": "ה ג גלריה יטהמ אבק123",
  "pages.interventions_page.pages_interventions_page_filter_by_admin_id": "סינון לפי Admin ID",
  "pages.interventions_page.pages_interventions_page_filter_by_admin_user_id": "סינון לפי Admin User ID",
  "pages.interventions_page.pages_interventions_page_filter_by_target_entity": "סינון לפי ישות יעד",
  "pages.interventions_page.pages_interventions_page_intervention_log": "התערבות לוג",
  "pages.interventions_page.pages_interventions_page_total_interventions": "סהכ התערבויות",
  "pages.management_page.adjust_the_search_term_to_inspect_another_occasion": "אדג׳וסט חיפוש טהרמ ל בדוק נוסף אירוע",
  "pages.management_page.adjust_the_search_term_to_inspect_another_user": "אדג׳וסט חיפוש טהרמ ל בדוק נוסף משתמש",
  "pages.management_page.management_console_load_error": "שגיאת טעינת מסוף ניהול",
  "pages.management_page.no_occasion_records_are_available_in_this_environment_yet": "אין אירוע רהקורדס הם זמין ב זה סביבה עדיין",
  "pages.management_page.no_platform_users_are_available_in_this_environment_yet": "אין פלטפורמה משתמשים הם זמין ב זה סביבה עדיין",
  "pages.management_page.pages_management_page_apply_search": "אפפלי חיפוש",
  "pages.management_page.pages_management_page_linked_actors": "מקושר גורמים",
  "pages.management_page.pages_management_page_page_size": "עמוד סיזה",
  "pages.management_page.pages_management_page_pending_gallery": "ממתין גלריה",
  "pages.management_page.pages_management_page_platform_directory_for_users_and_occasions": "פלטפורמה ספרייה עבור משתמשים ו אירועים",
  "pages.management_page.pages_management_page_resolution": "רזולוציה",
  "pages.management_page.pages_management_page_user": "משתמש",
  "pages.management_page.pages_management_page_view_details": "תצוגה פרטים",
  "pages.management_page.resolve_failed_delivery": "פתרון מסירה שנכשלה",
  "pages.management_page.review_account_links": "עיין בקישורי חשבון",
  "pages.management_page.review_gallery_queue": "סקור את תור הגלריה",
  "pages.management_page.review_reactivation": "סקור הפעלה מחדש",
  "pages.messaging_service_page.add_routing_rule": "הוסף ניתוב חוק",
  "pages.messaging_service_page.add_rule": "הוסף חוק",
  "pages.messaging_service_page.configure_a_sender_identity_for_a_provider_channel": "הגדר שולח זהות עבור ספק שירות צ׳אננהל",
  "pages.messaging_service_page.configure_country_or_global_routing_for_a_channel": "הגדר מדינה או גלובאל ניתוב עבור צ׳אננהל",
  "pages.messaging_service_page.create_sender_identity": "צור שולח זהות",
  "pages.messaging_service_page.default": "ברירת מחדל",
  "pages.messaging_service_page.default_sender": "ברירת מחדל שולח",
  "pages.messaging_service_page.edit_routing_rule": "ערוך ניתוב חוק",
  "pages.messaging_service_page.edit_sender_identity": "ערוך שולח זהות",
  "pages.messaging_service_page.email_address": "דואל כתובת",
  "pages.messaging_service_page.global": "גלובאל",
  "pages.messaging_service_page.inactive": "לא פעיל",
  "pages.messaging_service_page.messaging_service_could_not_be_loaded": "הודעות שירות יכול לא להיות נטען",
  "pages.messaging_service_page.phone_number": "טלפון מספר",
  "pages.messaging_service_page.provider": "ספק שירות",
  "pages.messaging_service_page.providers": "ספקי שירות",
  "pages.messaging_service_page.routing_rule_create_failed": "ניתוב חוק צור נכשל",
  "pages.messaging_service_page.routing_rule_created": "ניתוב חוק נוצר",
  "pages.messaging_service_page.routing_rule_disable_failed": "ניתוב חוק השבת נכשל",
  "pages.messaging_service_page.routing_rule_disabled": "ניתוב חוק מושבתות",
  "pages.messaging_service_page.routing_rule_update_failed": "ניתוב חוק עדכון נכשל",
  "pages.messaging_service_page.routing_rule_updated": "ניתוב חוק עודכן",
  "pages.messaging_service_page.routing_rules": "ניתוב חוקים",
  "pages.messaging_service_page.select_provider": "בחר ספק שירות",
  "pages.messaging_service_page.select_sender": "בחר שולח",
  "pages.messaging_service_page.sender": "שולח",
  "pages.messaging_service_page.sender_create_failed": "שולח צור נכשל",
  "pages.messaging_service_page.sender_created": "שולח נוצר",
  "pages.messaging_service_page.sender_disable_failed": "שולח השבת נכשל",
  "pages.messaging_service_page.sender_disabled": "שולח מושבתות",
  "pages.messaging_service_page.sender_identities": "שולח זהויות",
  "pages.messaging_service_page.sender_update_failed": "שולח עדכון נכשל",
  "pages.messaging_service_page.sender_updated": "שולח עודכן",
  "pages.moderation_page.moderation_queue_load_error": "שגיאת טעינת תור ניהול",
  "pages.moderation_page.pages_moderation_page_admin_moderation_is_platform_scoped_rejections_should_include": "מודרציית ניהול מוגבלת לפלטפורמה, ודחיות צריכות לכלול הקשר ברור",
  "pages.moderation_page.pages_moderation_page_asset_state": "נכס מצב",
  "pages.moderation_page.pages_moderation_page_bytes": "ביטהס",
  "pages.moderation_page.pages_moderation_page_clear_pending_guest_gallery_submissions_with_explicit_decisions": "נקה ממתין אורח גלריה הגשות עם מפורש החלטות",
  "pages.moderation_page.pages_moderation_page_explain_a_rejection_or_add_internal_context": "הסבר דחייה או הוסף הקשר פנימי",
  "pages.moderation_page.pages_moderation_page_filtered_moderation_items": "מסונן מודרציה פריטים",
  "pages.moderation_page.pages_moderation_page_moderation_note": "ניהול תוכן הערה",
  "pages.moderation_page.pages_moderation_page_no_note_recorded": "אין הערה רהקורדהד",
  "pages.moderation_page.pages_moderation_page_pending_queue": "ממתין תור",
  "pages.moderation_page.pages_moderation_page_recent_moderation_outcomes": "אחרונים מודרציה מחוץקומהס",
  "pages.moderation_page.pages_moderation_page_unknown_uploader": "לא ידוע ופלואדהר",
  "pages.motion_playground_page.abstract_floral_placeholder_seal_asset": "נכס חותם פרחוני מופשט",
  "pages.motion_playground_page.accent_color": "צבע מבטא",
  "pages.motion_playground_page.accent_layer": "שכבת הדגשה",
  "pages.motion_playground_page.accessibility_preview": "אקקהססיביליטי תצוגה מקדימה",
  "pages.motion_playground_page.animation_duration": "אנימאטיונ משך",
  "pages.motion_playground_page.animation_fps": "אנימאטיונ פפס",
  "pages.motion_playground_page.animation_state": "מצב אנימציה",
  "pages.motion_playground_page.anticipation": "הֶקדֵם",
  "pages.motion_playground_page.anticipation_amount": "כמות הציפיות",
  "pages.motion_playground_page.apply_color": "החל צבע",
  "pages.motion_playground_page.asset_browser": "דפדפן נכסים",
  "pages.motion_playground_page.asset_category": "קטגוריית נכסים",
  "pages.motion_playground_page.asset_comparison_mode": "מצב השוואת נכסים",
  "pages.motion_playground_page.asset_complexity": "נכס מורכבות",
  "pages.motion_playground_page.asset_layer_inspector": "מפקח שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_accent": "מבטא תפקיד שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_alignment": "יישור תפקידים בשכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_anchor": "עוגן תפקיד שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_base": "בסיס תפקידים של שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_depth": "עומק תפקיד שכבת הנכס",
  "pages.motion_playground_page.asset_layer_role_focus": "מיקוד תפקיד בשכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_frame": "מסגרת תפקיד של שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_inner_color": "תפקיד שכבת נכס צבע פנימי",
  "pages.motion_playground_page.asset_layer_role_motion_anchor": "עוגן תנועה של שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_placeholder_mark": "סימן מציין מיקום של שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_reference": "התייחסות לתפקיד שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_stage": "שלב תפקיד שכבת הנכס",
  "pages.motion_playground_page.asset_layer_role_supporting": "תמיכה בתפקידי שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_visible_face": "פן גלוי לתפקיד שכבת נכסים",
  "pages.motion_playground_page.asset_layer_role_wrap": "גלישת תפקידים בשכבת נכסים",
  "pages.motion_playground_page.asset_preset": "נכס הגדרה מראש",
  "pages.motion_playground_page.asset_presets": "הגדרות קבועות מראש של נכסים",
  "pages.motion_playground_page.asset_properties": "נכסי נכסים",
  "pages.motion_playground_page.assets": "נכסים",
  "pages.motion_playground_page.back_layer": "השכבה האחורית",
  "pages.motion_playground_page.background_assets": "נכסי רקע",
  "pages.motion_playground_page.background_color": "רקע קולור",
  "pages.motion_playground_page.backing_card_layer": "שכבת כרטיס גיבוי",
  "pages.motion_playground_page.balanced": "מְאוּזָן",
  "pages.motion_playground_page.balanced_gate_fold_open": "קיפול שער מאוזן פתוח",
  "pages.motion_playground_page.balanced_layered_cards_reveal": "קלפים מאוזנים שכבות חשיפת",
  "pages.motion_playground_page.balanced_ribbon_untie_and_lift": "סרט מאוזן להתיר ולהרים",
  "pages.motion_playground_page.balanced_scroll_unroll": "מגלילה מאוזנת",
  "pages.motion_playground_page.base_layer": "שכבת בסיס",
  "pages.motion_playground_page.black_envelope_for_modern_contrast_tests": "מעטפה שחורה למבחני ניגודיות מודרניים",
  "pages.motion_playground_page.black_tie_wedding": "בלאק טיה והדדינג",
  "pages.motion_playground_page.blue_envelope_for_formal_theme_tests": "מעטפה כחולה למבחני נושא פורמליים",
  "pages.motion_playground_page.border_color": "צבע גבול",
  "pages.motion_playground_page.border_layer": "שכבת גבול",
  "pages.motion_playground_page.border_style": "סגנון גבול",
  "pages.motion_playground_page.border_thickness": "עובי גבול",
  "pages.motion_playground_page.bottom": "תַחתִית",
  "pages.motion_playground_page.bow_compress": "קומפרס קשת",
  "pages.motion_playground_page.bow_layer": "שכבת קשת",
  "pages.motion_playground_page.bow_scale_amount": "כמות סולם קשת",
  "pages.motion_playground_page.card_lift": "הרמת כרטיסים",
  "pages.motion_playground_page.card_reveal": "חשיפת כרטיס",
  "pages.motion_playground_page.card_stagger": "כרטיס נדידה",
  "pages.motion_playground_page.cinematic_seal_break": "הפסקת חותם קולנועי",
  "pages.motion_playground_page.classic_envelope": "מעטפה קלאסית",
  "pages.motion_playground_page.classic_envelope_package_description": "קלאססיק הנוהלופה חבילה תיאור",
  "pages.motion_playground_page.classic_envelope_package_description_v2": "קלאססיק הנוהלופה חבילה תיאור ו2",
  "pages.motion_playground_page.classic_layered_set": "סט שכבות קלאסי",
  "pages.motion_playground_page.classic_layered_set_asset": "נכס סט קלאסי שכבות",
  "pages.motion_playground_page.classic_ring_seal_asset": "נכס חותם טבעת קלאסי",
  "pages.motion_playground_page.classic_seal": "חותם קלאסי",
  "pages.motion_playground_page.classic_theme": "נושא קלאסי",
  "pages.motion_playground_page.classic_white": "לבן קלאסי",
  "pages.motion_playground_page.classic_white_card_asset": "נכס כרטיס לבן קלאסי",
  "pages.motion_playground_page.clean_white_envelope_asset": "נכס מעטפה לבנה נקייה",
  "pages.motion_playground_page.collapse_debug_panel": "כווץ פאנל ניפוי באגים",
  "pages.motion_playground_page.color_palette_system": "מערכת לוח צבעים",
  "pages.motion_playground_page.comparison_lab": "מעבדת השוואה",
  "pages.motion_playground_page.compatibility": "קומפאטיביליטי",
  "pages.motion_playground_page.corner_radius": "קורנהר ראדיוס",
  "pages.motion_playground_page.cream_card_with_warm_accent_asset": "כרטיס קרם עם נכס מבטא חם",
  "pages.motion_playground_page.cream_envelope_with_gold_leaning_depth": "מעטפת שמנת עם עומק נוטה לזהב",
  "pages.motion_playground_page.cross_wrap": "עטיפה צולבת",
  "pages.motion_playground_page.cross_wrap_asset": "נכס גלישת צולב",
  "pages.motion_playground_page.current_animation": "אנימציה נוכחית",
  "pages.motion_playground_page.current_asset_set": "נוכחי נכס הגדר",
  "pages.motion_playground_page.current_duration": "משך נוכחי",
  "pages.motion_playground_page.current_easing": "הקלה נוכחית",
  "pages.motion_playground_page.current_invitation_format": "נוכחי הזמנה פורמאט",
  "pages.motion_playground_page.custom_colors": "צבעים מותאמים אישית",
  "pages.motion_playground_page.custom_cubic_bezier": "Bezier מעוקב מותאם אישית",
  "pages.motion_playground_page.custom_package": "קוסטומ חבילה",
  "pages.motion_playground_page.custom_package_description": "קוסטומ חבילה תיאור",
  "pages.motion_playground_page.custom_playground_package": "קוסטומ פלאיגרוונד חבילה",
  "pages.motion_playground_page.customizations": "התאמות אישיות",
  "pages.motion_playground_page.dark_card_with_metallic_accent_asset": "כרטיס כהה עם נכס מבטא מתכתי",
  "pages.motion_playground_page.dark_emerald": "אזמרגד כהה",
  "pages.motion_playground_page.dark_luxury": "יוקרה אפלה",
  "pages.motion_playground_page.dark_palette": "פלטה כהה",
  "pages.motion_playground_page.dark_stage": "במה אפלה",
  "pages.motion_playground_page.dark_stage_background_asset": "נכס רקע במה כהה",
  "pages.motion_playground_page.dark_theme": "נושא אפל",
  "pages.motion_playground_page.dashed": "דאשהד",
  "pages.motion_playground_page.debug": "לְנַפּוֹת",
  "pages.motion_playground_page.delay": "לְעַכֵּב",
  "pages.motion_playground_page.delete_preset": "מחק הגדרה מראש",
  "pages.motion_playground_page.deprecated": "דהפרהקאטהד",
  "pages.motion_playground_page.depth_strength": "עומק חוזק",
  "pages.motion_playground_page.details_card_layer": "פרטים שכבת כרטיס",
  "pages.motion_playground_page.double": "לְהַכפִּיל",
  "pages.motion_playground_page.double_ribbon": "סרט כפול",
  "pages.motion_playground_page.double_ribbon_asset": "נכס סרט כפול",
  "pages.motion_playground_page.down": "לְמַטָה",
  "pages.motion_playground_page.dramatic_fan": "מעריץ דרמטי",
  "pages.motion_playground_page.dropped_frames": "דרופפהד פראמהס",
  "pages.motion_playground_page.duplicate_preset": "שכפול הגדרה מראש",
  "pages.motion_playground_page.ease": "קַלוּת",
  "pages.motion_playground_page.ease_in": "קל להיכנס",
  "pages.motion_playground_page.ease_in_out": "האסה ב מחוץ",
  "pages.motion_playground_page.ease_out": "קל החוצה",
  "pages.motion_playground_page.easing": "הֲפָגָה",
  "pages.motion_playground_page.edge_layer": "שכבת קצה",
  "pages.motion_playground_page.elegance": "אֵלֶגַנטִיוּת",
  "pages.motion_playground_page.emerald_envelope_for_dark_premium_tests": "מעטפת אמרלד למבחני פרימיום כהים",
  "pages.motion_playground_page.envelope_assets": "נכסי מעטפה",
  "pages.motion_playground_page.evaluation": "הערכה",
  "pages.motion_playground_page.exaggerated_seal_fracture_for_limit_testing": "שבר איטום מוגזם לבדיקת גבול",
  "pages.motion_playground_page.expand_debug_panel": "הרחב את פאנל ניפוי באגים",
  "pages.motion_playground_page.experimental_push_motion_further_than_feels_safe": "תנועת דחיפה נסיונית רחוק יותר מאשר מרגיש בטוח",
  "pages.motion_playground_page.family_occasion_suite": "פאמילי אירוע סוויטה",
  "pages.motion_playground_page.fan_angle": "זווית מאוורר",
  "pages.motion_playground_page.fan_distance": "מרחק מאוורר",
  "pages.motion_playground_page.fan_out": "מאוורר החוצה",
  "pages.motion_playground_page.fanned": "מאוורר",
  "pages.motion_playground_page.fast": "מָהִיר",
  "pages.motion_playground_page.fast_card_fan_out": "מאוורר כרטיסים מהיר",
  "pages.motion_playground_page.fast_half_fold_open": "מהיר חצי קיפול פתוח",
  "pages.motion_playground_page.fast_minimal_anticipation_no_overshoot": "ציפייה מינימלית מהירה ללא חריגה",
  "pages.motion_playground_page.fast_ribbon_slide_reveal": "גילוי שקופיות סרט מהיר",
  "pages.motion_playground_page.fast_scroll_unroll": "פאסט סקרולל ונרולל",
  "pages.motion_playground_page.fast_skip_mode": "מצב דילוג מהיר",
  "pages.motion_playground_page.final_layout_style": "סגנון פריסה סופי",
  "pages.motion_playground_page.first_fold": "קיפול ראשון",
  "pages.motion_playground_page.flap_layer": "שכבת דש",
  "pages.motion_playground_page.flap_open": "דש פתוח",
  "pages.motion_playground_page.flap_open_angle": "זווית פתוחה של דש",
  "pages.motion_playground_page.flap_style": "סגנון דש",
  "pages.motion_playground_page.flat_modern_seal_asset": "נכס חותם מודרני שטוח",
  "pages.motion_playground_page.floral_placeholder": "מציין מקום פרחוני",
  "pages.motion_playground_page.fold_angle": "זווית קיפול",
  "pages.motion_playground_page.fold_direction": "כיוון קיפול",
  "pages.motion_playground_page.fold_stagger": "קיפול השהיה מדורגת",
  "pages.motion_playground_page.fold_type": "סוג קיפול",
  "pages.motion_playground_page.formal_multi_event_wedding": "פורמאל מרובה אירוע והדדינג",
  "pages.motion_playground_page.formal_wedding_invitation": "פורמאל והדדינג הזמנה",
  "pages.motion_playground_page.frame_time": "זמן מסגרת",
  "pages.motion_playground_page.front_layer": "שכבה קדמית",
  "pages.motion_playground_page.full_invitation": "הזמנה מלאה",
  "pages.motion_playground_page.future_asset_types": "סוגי נכסים עתידיים",
  "pages.motion_playground_page.future_assets_placeholder": "מציין מקום של נכסים עתידיים",
  "pages.motion_playground_page.future_diagnostics": "אבחון עתידי",
  "pages.motion_playground_page.gate_fold": "קיפול שער",
  "pages.motion_playground_page.geometric_placeholder": "מציין מיקום גיאומטרי",
  "pages.motion_playground_page.geometric_placeholder_seal_asset": "נכס מציין מיקום גיאומטרי",
  "pages.motion_playground_page.gold_accent": "מבטא זהב",
  "pages.motion_playground_page.grid_layer": "שכבת רשת",
  "pages.motion_playground_page.half_fold": "חצי קיפול",
  "pages.motion_playground_page.hide": "לְהַסתִיר",
  "pages.motion_playground_page.horizontal_band_layer": "שכבת להקה אופקית",
  "pages.motion_playground_page.inner_lining_color": "צבע בטנה פנימית",
  "pages.motion_playground_page.invitation_assets": "נכסי הזמנה",
  "pages.motion_playground_page.invitation_exit": "יציאה מהזמנה",
  "pages.motion_playground_page.invitation_lift_amount": "סכום העלאת הזמנה",
  "pages.motion_playground_page.invitation_travel_distance": "מרחק נסיעה בהזמנה",
  "pages.motion_playground_page.landscape_invitation": "לאנדסקאפה הזמנה",
  "pages.motion_playground_page.large_fan_motion_for_layout_limit_testing": "תנועת מאוורר גדולה לבדיקת מגבלת פריסה",
  "pages.motion_playground_page.last_command": "פקודה אחרונה",
  "pages.motion_playground_page.layered_set_assets": "נכסי סט שכבות",
  "pages.motion_playground_page.layered_suite": "סוויטה שכבתית",
  "pages.motion_playground_page.layered_suite_package_description": "תיאור חבילת סוויטה שכבתית",
  "pages.motion_playground_page.left": "להפט",
  "pages.motion_playground_page.lift": "מַעֲלִית",
  "pages.motion_playground_page.linear": "ליניארי",
  "pages.motion_playground_page.lining_layer": "שכבת בטנה",
  "pages.motion_playground_page.live_preview": "חי תצוגה מקדימה",
  "pages.motion_playground_page.load_preset": "טען הגדרה מראש",
  "pages.motion_playground_page.loop_continuously": "לולאה ברציפות",
  "pages.motion_playground_page.low_power_mode": "לוו פווהר מצב",
  "pages.motion_playground_page.luxury": "לוקסורי",
  "pages.motion_playground_page.luxury_cream": "קרם יוקרתי",
  "pages.motion_playground_page.luxury_feel": "תחושת יוקרה",
  "pages.motion_playground_page.luxury_palette": "פלטת יוקרה",
  "pages.motion_playground_page.luxury_ribbon": "סרט יוקרתי",
  "pages.motion_playground_page.luxury_ribbon_asset": "נכס סרט יוקרתי",
  "pages.motion_playground_page.luxury_save_the_date": "לוקסורי שמור דאטה",
  "pages.motion_playground_page.luxury_slow": "יוקרה איטי",
  "pages.motion_playground_page.luxury_theme": "נושא יוקרה",
  "pages.motion_playground_page.main_card_focus": "פוקוס כרטיס ראשי",
  "pages.motion_playground_page.main_card_layer": "שכבת הכרטיס הראשי",
  "pages.motion_playground_page.main_card_only": "כרטיס ראשי בלבד",
  "pages.motion_playground_page.manual_replay": "שידור חוזר ידני",
  "pages.motion_playground_page.medium_speed_small_anticipation_small_overshoot": "מהירות בינונית ציפייה קטנה",
  "pages.motion_playground_page.minimal_band": "להקה מינימלית",
  "pages.motion_playground_page.minimal_band_asset": "נכס להקה מינימלי",
  "pages.motion_playground_page.minimal_cream": "קרם מינימלי",
  "pages.motion_playground_page.minimal_modern": "מינימלי מודרני",
  "pages.motion_playground_page.minimal_modern_card_asset": "נכס כרטיס מודרני מינימלי",
  "pages.motion_playground_page.minimal_modern_very_little_movement_clean_motion": "מינימלי מודרני תנועה קטנה מאוד תנועה נקייה",
  "pages.motion_playground_page.minimal_palette": "פלטה מינימלית",
  "pages.motion_playground_page.minimal_theme": "נושא מינימלי",
  "pages.motion_playground_page.minimal_white": "מינימלי לבן",
  "pages.motion_playground_page.mobile_first_invite": "הזמנה מותאמת מובייל תחילה",
  "pages.motion_playground_page.mobile_story": "נייד סטורי",
  "pages.motion_playground_page.modern_black": "שחור מודרני",
  "pages.motion_playground_page.modern_feel": "תחושה מודרנית",
  "pages.motion_playground_page.modern_minimal": "מינימלי מודרני",
  "pages.motion_playground_page.modern_minimal_package_description": "מודהרנ מינימאל חבילה תיאור",
  "pages.motion_playground_page.modern_seal": "חותם מודרני",
  "pages.motion_playground_page.modern_theme": "נושא מודרני",
  "pages.motion_playground_page.modern_wedding_invitation": "מודהרנ והדדינג הזמנה",
  "pages.motion_playground_page.monogram_placeholder": "מציין מקום של מונוגרמה",
  "pages.motion_playground_page.monogram_placeholder_seal_asset": "נכס חותם מציין מונוגרמה",
  "pages.motion_playground_page.motion": "מוטיונ",
  "pages.motion_playground_page.motion_preset": "מוטיונ הגדרה מראש",
  "pages.motion_playground_page.motion_timeline": "ציר זמן של תנועה",
  "pages.motion_playground_page.multi_card_set": "מרובה קארד הגדר",
  "pages.motion_playground_page.multi_card_weekend_suite": "מרובה קארד ויקהנד סוויטה",
  "pages.motion_playground_page.neutral_card_with_gold_accent_asset": "כרטיס ניטרלי עם נכס מבטא זהב",
  "pages.motion_playground_page.neutral_stage": "שלב ניטרלי",
  "pages.motion_playground_page.neutral_stage_background_asset": "נכס רקע שלב ניטרלי",
  "pages.motion_playground_page.no_animation_mode": "אין אנימאטיונ מצב",
  "pages.motion_playground_page.number_of_cards": "מספר קלפים",
  "pages.motion_playground_page.originality": "וריגינאליטי",
  "pages.motion_playground_page.overall": "בסך הכל",
  "pages.motion_playground_page.overall_appeal": "ערעור כולל",
  "pages.motion_playground_page.overshoot": "לְהַחטִיא אֵת הַמַטָרָה",
  "pages.motion_playground_page.overshoot_amount": "כמות חריגה",
  "pages.motion_playground_page.package_editor": "חבילה הדיטור",
  "pages.motion_playground_page.package_export": "חבילה ייצוא",
  "pages.motion_playground_page.package_format_warning": "חבילה פורמאט אזהרה",
  "pages.motion_playground_page.package_list": "חבילה ליסט",
  "pages.motion_playground_page.package_name": "חבילה שם",
  "pages.motion_playground_page.package_rating": "חבילה ראטינג",
  "pages.motion_playground_page.package_versioning": "ניהול גרסאות חבילה",
  "pages.motion_playground_page.packages": "חבילות",
  "pages.motion_playground_page.pages_motion_playground_page_animation": "הַנפָּשָׁה",
  "pages.motion_playground_page.pages_motion_playground_page_animation_selector": "בורר אנימציה",
  "pages.motion_playground_page.pages_motion_playground_page_choreographs_anticipation_flap_depth_card_overshoot_and_settle": "כוריאוגרפים ציפייה דש עומק כרטיס להחמיר ולהתיישב",
  "pages.motion_playground_page.pages_motion_playground_page_envelope_open": "מעטפה פתוחה",
  "pages.motion_playground_page.pages_motion_playground_page_fold_and_perspective_experiments": "ניסויים של קיפול וראייה",
  "pages.motion_playground_page.pages_motion_playground_page_fold_open": "קיפול פתוח",
  "pages.motion_playground_page.pages_motion_playground_page_layered_cards": "כרטיסים בשכבות",
  "pages.motion_playground_page.pages_motion_playground_page_motion_playground": "מגרש משחקים בתנועה",
  "pages.motion_playground_page.pages_motion_playground_page_playback": "השמעה",
  "pages.motion_playground_page.pages_motion_playground_page_ribbon_release_and_card_lift_experiments": "ניסויי שחרור סרט והרמת כרטיסים",
  "pages.motion_playground_page.pages_motion_playground_page_scroll_unroll": "גלול שחרור",
  "pages.motion_playground_page.pages_motion_playground_page_seal_break_flap_open_and_card_reveal_timing_tests": "בדיקות תזמון של פתיחת דש לשבור חותם וחשיפת כרטיס",
  "pages.motion_playground_page.pages_motion_playground_page_staggered_card_depth_experiments": "ניסויי עומק כרטיס מדורג",
  "pages.motion_playground_page.pages_motion_playground_page_the_motion_playground_surface_is_disabled": "משטח ה-Motion Playground מושבת",
  "pages.motion_playground_page.pages_motion_playground_page_timing": "תִזמוּן",
  "pages.motion_playground_page.pages_motion_playground_page_unroll_and_settle_experiments": "פרוש והסדר ניסויים",
  "pages.motion_playground_page.pages_motion_playground_page_wax_seal_break": "הפסקת חותם שעווה",
  "pages.motion_playground_page.palette": "לוּחַ הַצְבָעִים",
  "pages.motion_playground_page.pan_x": "פאן X",
  "pages.motion_playground_page.pan_y": "פאן י",
  "pages.motion_playground_page.paper_assets": "נכסי נייר",
  "pages.motion_playground_page.paper_expand": "הרחבת נייר",
  "pages.motion_playground_page.paper_layer": "שכבת נייר",
  "pages.motion_playground_page.parameter_diff": "פרמטר הפרש",
  "pages.motion_playground_page.pause": "הַפסָקָה",
  "pages.motion_playground_page.performance": "פהרפורמאנקה",
  "pages.motion_playground_page.performance_profile": "פהרפורמאנקה פרופיל",
  "pages.motion_playground_page.personalization_preview": "פהרסונאליזאטיונ תצוגה מקדימה",
  "pages.motion_playground_page.perspective": "פֶּרספֶּקטִיבָה",
  "pages.motion_playground_page.placeholder": "פלאקההולדהר",
  "pages.motion_playground_page.plain_circle": "עיגול רגיל",
  "pages.motion_playground_page.play_progress": "שחק התקדמות",
  "pages.motion_playground_page.playback_speed": "מהירות השמעה",
  "pages.motion_playground_page.portrait_invitation": "פורטראיט הזמנה",
  "pages.motion_playground_page.premium_event_sequence": "פרהמיומ אירוע סהקוהנקה",
  "pages.motion_playground_page.premium_feel": "תחושה פרימיום",
  "pages.motion_playground_page.premium_guest_reveal": "פרהמיומ אורח רהוהאל",
  "pages.motion_playground_page.preset_name": "שם מוגדר מראש",
  "pages.motion_playground_page.presets": "הגדרות קבועות מראש",
  "pages.motion_playground_page.preview_mode": "תצוגה מקדימה מצב",
  "pages.motion_playground_page.primary_color": "צבע ראשי",
  "pages.motion_playground_page.production_ready": "מוצריונ מוכן",
  "pages.motion_playground_page.quick_seal_split_then_direct_reveal": "פיצול חותם מהיר ואז חשיפה ישירה",
  "pages.motion_playground_page.realism": "רֵיאָלִיזם",
  "pages.motion_playground_page.reduced_motion_mode": "רהדוקהד מוטיונ מצב",
  "pages.motion_playground_page.render_count": "רהנדהר מספר",
  "pages.motion_playground_page.replay": "רהפלאי",
  "pages.motion_playground_page.replay_automation": "אוטומציה חוזרת",
  "pages.motion_playground_page.replay_every_10_seconds": "שידור חוזר כל 10 שניות",
  "pages.motion_playground_page.replay_every_2_seconds": "שידור חוזר כל 2 שניות",
  "pages.motion_playground_page.replay_every_5_seconds": "שידור חוזר כל 5 שניות",
  "pages.motion_playground_page.reset_to_default": "אפס לברירת מחדל",
  "pages.motion_playground_page.resume": "קוֹרוֹת חַיִים",
  "pages.motion_playground_page.reveal": "לְגַלוֹת",
  "pages.motion_playground_page.reveal_delay": "חשוף עיכוב",
  "pages.motion_playground_page.ribbon_assets": "נכסי סרט",
  "pages.motion_playground_page.ribbon_fade_amount": "כמות דהיית הסרט",
  "pages.motion_playground_page.ribbon_separate": "סרט נפרד",
  "pages.motion_playground_page.ribbon_slide_distance": "מרחק החלקת סרט",
  "pages.motion_playground_page.ribbon_untie": "סרט להתיר",
  "pages.motion_playground_page.right": "ריגהט",
  "pages.motion_playground_page.roll_size": "גודל גליל",
  "pages.motion_playground_page.roll_start": "רול התחל",
  "pages.motion_playground_page.rotation": "רוֹטַציָה",
  "pages.motion_playground_page.royal_blue": "כחול מלכותי",
  "pages.motion_playground_page.royal_card_palette_asset": "נכס פלטת כרטיסים מלכותיים",
  "pages.motion_playground_page.royal_invitation": "מלכותי הזמנה",
  "pages.motion_playground_page.royal_invitation_package_description": "מלכותי הזמנה חבילה תיאור",
  "pages.motion_playground_page.royal_layered_set": "סט מלכותי שכבות",
  "pages.motion_playground_page.royal_layered_set_asset": "נכס סט שכבות מלכותי",
  "pages.motion_playground_page.royal_palette": "פלטה מלכותית",
  "pages.motion_playground_page.royal_theme": "נושא מלכותי",
  "pages.motion_playground_page.sample_couple_name": "סאמפלה קוופלה שם",
  "pages.motion_playground_page.sample_event_name": "סאמפלה אירוע שם",
  "pages.motion_playground_page.sample_guest_name": "סאמפלה אורח שם",
  "pages.motion_playground_page.sample_initials": "סאמפלה יניטיאלס",
  "pages.motion_playground_page.sample_monogram": "סאמפלה מונוגראמ",
  "pages.motion_playground_page.sample_occasion_theme": "סאמפלה אירוע תהמה",
  "pages.motion_playground_page.save_package": "שמור חבילה",
  "pages.motion_playground_page.save_palette": "שמור לוח",
  "pages.motion_playground_page.save_preset": "שמור הגדרה מראש",
  "pages.motion_playground_page.save_the_date": "שמור דאטה",
  "pages.motion_playground_page.saved_palette": "לוח שמור",
  "pages.motion_playground_page.scale": "סקאלה",
  "pages.motion_playground_page.seal_anchor_layer": "שכבת עוגן חותם",
  "pages.motion_playground_page.seal_body_layer": "שכבת גוף חותם",
  "pages.motion_playground_page.seal_border_layer": "שכבת גבול חותם",
  "pages.motion_playground_page.seal_break": "שבירת חותם",
  "pages.motion_playground_page.seal_break_balanced_reveal_and_settle": "חותם לשבור מאוזן לחשוף ולהתיישב",
  "pages.motion_playground_page.seal_break_delay": "עיכוב שבירת חותם",
  "pages.motion_playground_page.seal_break_intensity": "עוצמת שבירת חותם",
  "pages.motion_playground_page.seal_mark_layer": "שכבת סימן חותם",
  "pages.motion_playground_page.seal_piece_spread": "ממרח חתיכת חותם",
  "pages.motion_playground_page.second_fold": "קיפול שני",
  "pages.motion_playground_page.secondary_card_layer": "שכבת כרטיסים משנית",
  "pages.motion_playground_page.secondary_color": "צבע משני",
  "pages.motion_playground_page.selected_asset": "נכס נבחר",
  "pages.motion_playground_page.settle": "לִשְׁקוֹעַ",
  "pages.motion_playground_page.settle_duration": "הסדר משך",
  "pages.motion_playground_page.shadow_blur": "טשטוש צללים",
  "pages.motion_playground_page.shadow_depth": "עומק הצל",
  "pages.motion_playground_page.shadow_growth": "צמיחת צל",
  "pages.motion_playground_page.shadow_intensity": "עוצמת הצללים",
  "pages.motion_playground_page.shadow_layer": "שכבת צל",
  "pages.motion_playground_page.shadow_strength": "חוזק צל",
  "pages.motion_playground_page.show": "לְהַצִיג",
  "pages.motion_playground_page.side_spread": "משטח צד",
  "pages.motion_playground_page.simple_circular_seal_asset": "נכס חותם עגול פשוט",
  "pages.motion_playground_page.single_preview": "תצוגה מקדימה בודדת",
  "pages.motion_playground_page.slow_layered_cards_depth_reveal": "קלפים בשכבות איטיות חשיפת עומק",
  "pages.motion_playground_page.slow_luxury_style_large_anticipation_soft_overshoot": "איטי יוקרה סגנון גדול ציפייה רך יתר על המידה",
  "pages.motion_playground_page.slow_ribbon_release_with_long_settle": "שחרור סרט איטי עם התיישבות ארוכה",
  "pages.motion_playground_page.slow_scroll_unroll_with_depth": "גלגול איטי עם עומק",
  "pages.motion_playground_page.slow_tri_fold_with_soft_settle": "קיפול תלת איטי עם התיישבות רכה",
  "pages.motion_playground_page.slower_seal_break_with_soft_depth": "שבירת איטום איטית יותר עם עומק רך",
  "pages.motion_playground_page.smooth_flat_paper_asset": "נכס נייר שטוח חלק",
  "pages.motion_playground_page.smooth_paper": "נייר חלק",
  "pages.motion_playground_page.soft": "רַך",
  "pages.motion_playground_page.solid": "סוליד",
  "pages.motion_playground_page.speed": "מְהִירוּת",
  "pages.motion_playground_page.square_invitation": "סקוארה הזמנה",
  "pages.motion_playground_page.stack_lift": "הרמת מחסנית",
  "pages.motion_playground_page.stacked": "מְגוּבָּב",
  "pages.motion_playground_page.standard_motion_mode": "רגיל מוטיונ מצב",
  "pages.motion_playground_page.straight": "יָשָׁר",
  "pages.motion_playground_page.supports_couple_name": "סופפורטס קוופלה שם",
  "pages.motion_playground_page.supports_event_name": "סופפורטס אירוע שם",
  "pages.motion_playground_page.supports_guest_name": "סופפורטס אורח שם",
  "pages.motion_playground_page.supports_initials": "סופפורטס יניטיאלס",
  "pages.motion_playground_page.supports_monogram": "סופפורטס מונוגראמ",
  "pages.motion_playground_page.supports_occasion_theme": "סופפורטס אירוע תהמה",
  "pages.motion_playground_page.surface_layer": "שכבת פני השטח",
  "pages.motion_playground_page.surface_visible": "משטח גלוי",
  "pages.motion_playground_page.texture_level": "רמת מרקם",
  "pages.motion_playground_page.theme": "תהמה",
  "pages.motion_playground_page.theme_colors": "צבעי נושא",
  "pages.motion_playground_page.theme_preview": "תהמה תצוגה מקדימה",
  "pages.motion_playground_page.thickness": "עוֹבִי",
  "pages.motion_playground_page.thin_ribbon": "סרט דק",
  "pages.motion_playground_page.thin_ribbon_asset": "נכס סרט דק",
  "pages.motion_playground_page.top": "רֹאשׁ",
  "pages.motion_playground_page.tri_fold": "טרי פולד",
  "pages.motion_playground_page.triangle": "מְשּוּלָשׁ",
  "pages.motion_playground_page.unroll_direction": "כיוון פתיחה",
  "pages.motion_playground_page.unroll_distance": "מרחק פתיחה",
  "pages.motion_playground_page.unroll_speed": "ונרולל ספיד",
  "pages.motion_playground_page.up": "לְמַעלָה",
  "pages.motion_playground_page.user_custom": "משתמש מותאם אישית",
  "pages.motion_playground_page.user_custom_assets": "נכסים מותאמים אישית של משתמש",
  "pages.motion_playground_page.variant": "גִרְסָה אַחֶרֶת",
  "pages.motion_playground_page.variant_a_fast": "וריאנט מהיר",
  "pages.motion_playground_page.variant_b_balanced": "וריאנט B מאוזן",
  "pages.motion_playground_page.variant_c_luxury": "וריאנט ג יוקרה",
  "pages.motion_playground_page.variant_d_cinematic": "וריאנט ד קולנועי",
  "pages.motion_playground_page.variant_e_modern_minimal": "וריאנט E מודרני מינימלי",
  "pages.motion_playground_page.variant_f_experimental": "וריאנט F ניסיוני",
  "pages.motion_playground_page.version": "גרסה",
  "pages.motion_playground_page.version_count": "גרסה מספר",
  "pages.motion_playground_page.vertical_band_layer": "שכבת פס אנכית",
  "pages.motion_playground_page.vertical_reel": "והרטיקאל ריל",
  "pages.motion_playground_page.vertical_wrap": "עטיפה אנכית",
  "pages.motion_playground_page.vertical_wrap_asset": "נכס גלישה אנכית",
  "pages.motion_playground_page.very_slow_cinematic_heavy_shadow_changes_large_depth_effect": "איטי מאוד קולנועי צל כבד משנה אפקט עומק גדול",
  "pages.motion_playground_page.vignette_layer": "שכבת ויגנט",
  "pages.motion_playground_page.visual_elegance": "אלגנטיות ויזואלית",
  "pages.motion_playground_page.visual_scoring": "ניקוד חזותי",
  "pages.motion_playground_page.warm_flat_paper_asset": "נכס נייר שטוח חם",
  "pages.motion_playground_page.warm_minimal_cream_envelope_asset": "נכס מעטפת קרם מינימלית חמה",
  "pages.motion_playground_page.warm_paper": "נייר חם",
  "pages.motion_playground_page.wax_seal_assets": "נכסי חותמת שעווה",
  "pages.motion_playground_page.wax_seal_reveal": "ואקס סהאל רהוהאל",
  "pages.motion_playground_page.wax_seal_reveal_package_description": "ואקס סהאל רהוהאל חבילה תיאור",
  "pages.motion_playground_page.zoom": "זום",
  "pages.observability_page.pages_observability_page_automation": "אוטומציה",
  "pages.observability_page.pages_observability_page_campaign": "קמפיין",
  "pages.observability_page.pages_observability_page_completed_traces": "הושלם עקבות",
  "pages.observability_page.pages_observability_page_event_type_trace_id_module": "סוג אירוע, Trace ID ומודול",
  "pages.observability_page.pages_observability_page_events_last": "אירועים אחרון",
  "pages.observability_page.pages_observability_page_failure_events": "כשל אירועים",
  "pages.observability_page.pages_observability_page_filters": "מסננים",
  "pages.observability_page.pages_observability_page_guest_rsvp_completion_rate": "שיעור השלמת RSVP של אורחים",
  "pages.observability_page.pages_observability_page_journey": "מסע",
  "pages.observability_page.pages_observability_page_journey_metrics": "מסע מדדים",
  "pages.observability_page.pages_observability_page_module": "מודול",
  "pages.observability_page.pages_observability_page_observability": "תצפיתיות",
  "pages.observability_page.pages_observability_page_ok": "וק",
  "pages.observability_page.pages_observability_page_product_events": "מוצר אירועים",
  "pages.observability_page.pages_observability_page_recent_errors": "אחרון שגיאות",
  "pages.observability_page.pages_observability_page_recent_product_events": "אחרון מוצר אירועים",
  "pages.observability_page.pages_observability_page_system": "מערכת",
  "pages.observability_page.pages_observability_page_this_surface_exposes_product_level_events_and_traces": "זה ממשק חושף מוצר רמה אירועים ו עקבות",
  "pages.observability_page.pages_observability_page_top_modules": "מודולים מובילים",
  "pages.observability_page.pages_observability_page_trace": "עקבה",
  "pages.observability_page.pages_observability_page_trace_guest_planner_vendor_and_automation_behavior": "עקבה אורח מתכנן ספק ו אוטומאטיונ בההאויור",
  "pages.observability_page.pages_observability_page_tracked_events": "במעקב אירועים",
  "pages.placeholder_feature_page.pages_placeholder_feature_page_future_admin_tasks_should_extend_this_route_instead": "עתידי ניהול משימות צריך הרחב זה נתיב ינסטהאד",
  "pages.rollout_page.pages_rollout_page_backup_and_restore": "גיבוי ו שחזור",
  "pages.rollout_page.pages_rollout_page_consistency_violations": "עקביות הפרות",
  "pages.rollout_page.pages_rollout_page_critical_violations": "קריטי הפרות",
  "pages.rollout_page.pages_rollout_page_data_consistency": "נתונים עקביות",
  "pages.rollout_page.pages_rollout_page_dead_letter": "מת מכתב",
  "pages.rollout_page.pages_rollout_page_dependency_degradation": "תלות ירידה",
  "pages.rollout_page.pages_rollout_page_errors": "שגיאות",
  "pages.rollout_page.pages_rollout_page_fallback": "גיבוי",
  "pages.rollout_page.pages_rollout_page_inspect_platform_queues_before_direct_intervention": "בדוק פלטפורמה תורים לפני דירהקט התערבות",
  "pages.rollout_page.pages_rollout_page_latest_successful_manifest": "אחרון מוצלח מניפסט",
  "pages.rollout_page.pages_rollout_page_launch_posture": "השקה מצב",
  "pages.rollout_page.pages_rollout_page_launch_readiness": "השקה מוכנות",
  "pages.rollout_page.pages_rollout_page_no_failure_reason": "אין כשל סיבה",
  "pages.rollout_page.pages_rollout_page_no_successful_backup_yet": "אין מוצלח גיבוי עדיין",
  "pages.rollout_page.pages_rollout_page_open_control": "פתח בקרה",
  "pages.rollout_page.pages_rollout_page_operational_thresholds": "תפעולי ספים",
  "pages.rollout_page.pages_rollout_page_platform_controls_stay_centralized_so_support_and_moderation": "פלטפורמה בקרות הישאר קהנטראליזהד כך תמיכה ו מודרציה",
  "pages.rollout_page.pages_rollout_page_queued": "בתור",
  "pages.rollout_page.pages_rollout_page_recent_artifacts": "אחרון ארטיפקטים",
  "pages.rollout_page.pages_rollout_page_recent_invariant_violations": "אחרון אינווריאנט הפרות",
  "pages.rollout_page.pages_rollout_page_recent_publishing_jobs": "אחרון פרסום עבודות",
  "pages.rollout_page.pages_rollout_page_recent_runtime_errors": "אחרונים זמן ריצה שגיאות",
  "pages.rollout_page.pages_rollout_page_requests": "בקשות",
  "pages.rollout_page.pages_rollout_page_restore_cadence": "שחזור קצב",
  "pages.rollout_page.pages_rollout_page_rollout_and_controls": "השקה ו בקרות",
  "pages.rollout_page.pages_rollout_page_runtime_health": "זמן ריצה תקינות",
  "pages.rollout_page.pages_rollout_page_server": "שרת",
  "pages.rollout_page.pages_rollout_page_successful_backup_manifests": "מוצלח גיבוי מניפסטים",
  "pages.rollout_page.pages_rollout_page_system_controls": "מערכת בקרות",
  "pages.rollout_page.pages_rollout_page_total_violations_across": "סהכ הפרות ברחבי",
  "pages.rollout_page.pages_rollout_page_tracked_invariants": "במעקב אינווריאנטים",
  "pages.rollout_page.pages_rollout_page_warning_violations": "אזהרה הפרות",
  "pages.rollout_page.pages_rollout_page_worker": "עובד",
  "pages.rollout_page.risk": "סיכון",
  "pages.rollout_page.the_platform_operations_view_could_not_be_loaded": "פלטפורמה תפעול תצוגה יכול לא להיות נטען",
  "pages.search_page.admin_search_results_load_error": "שגיאת טעינת תוצאות חיפוש של מנהל מערכת",
  "pages.settings_page.disable_normal_public_registrations_and_route_new_signups_to_the_waitlist": "השבת רגיל ציבורי רהגיסטראטיונס ו נתיב חדש הרשמות ל רשימת המתנה",
  "pages.settings_page.last_updated": "עודכן לאחרונה",
  "pages.settings_page.new_signups_can_register_normally_again": "חדש הרשמות יכול רהגיסטהר נורמאללי שוב",
  "pages.settings_page.new_signups_now_route_to_the_waitlist": "חדש הרשמות כעת נתיב ל רשימת המתנה",
  "pages.settings_page.public_settings_could_not_be_loaded": "לא ניתן היה לטעון הגדרות ציבוריות",
  "pages.settings_page.public_signup": "ציבורי הרשמה",
  "pages.settings_page.registration_controls": "הרשמה בקרות",
  "pages.settings_page.waitlist_mode": "רשימת המתנה מצב",
  "pages.settings_page.waitlist_mode_update_failed": "רשימת המתנה מצב עדכון נכשל",
  "pages.settings_page.waitlist_mode_updated": "רשימת המתנה מצב עודכן",
  "pages.storybook_page.pages_storybook_page_embedded_storybook_for_all_shared_tov_plus_ui": "Storybook מוטמע לכל רכיבי ה-UI המשותפים של Tov+",
  "pages.storybook_page.pages_storybook_page_open_in_new_tab": "פתח ב חדש טאב",
  "pages.storybook_page.pages_storybook_page_ui_development": "פיתוח UI",
  "pages.support_page.operations_console_load_error": "שגיאת טעינת מסוף הפעולות",
  "pages.support_page.pages_support_page_access_and_campaigns": "גישה ו קמפיינים",
  "pages.support_page.pages_support_page_action_policy": "פעולה מדיניות",
  "pages.support_page.pages_support_page_actor_inspections": "גורם בדיקות",
  "pages.support_page.pages_support_page_actor_links": "גורם קישורים",
  "pages.support_page.pages_support_page_actor_matches": "גורם מאטצ׳הס",
  "pages.support_page.pages_support_page_actors": "גורמים",
  "pages.support_page.pages_support_page_bidirectional": "בידירהקטיונאל",
  "pages.support_page.pages_support_page_blocked_tasks": "חסום משימות",
  "pages.support_page.pages_support_page_bounded_support_action": "מוגבל תמיכה פעולה",
  "pages.support_page.pages_support_page_campaigns": "קמפיינים",
  "pages.support_page.pages_support_page_connection": "חיבור",
  "pages.support_page.pages_support_page_deliveries": "מסירות",
  "pages.support_page.pages_support_page_distribution": "הפצה",
  "pages.support_page.pages_support_page_distribution_matches": "הפצה מאטצ׳הס",
  "pages.support_page.pages_support_page_distributions": "הפצות",
  "pages.support_page.pages_support_page_effective_admin_roles": "הפפהקטיוה ניהול תפקידים",
  "pages.support_page.pages_support_page_explain_why_this_action_is_required": "הסבר מדוע פעולה זו נדרשת",
  "pages.support_page.pages_support_page_failed_jobs": "נכשל עבודות",
  "pages.support_page.pages_support_page_groups": "קבוצות",
  "pages.support_page.pages_support_page_households": "משקי בית",
  "pages.support_page.pages_support_page_invariants": "אינווריאנטים",
  "pages.support_page.pages_support_page_latest_job": "אחרון עבודה",
  "pages.support_page.pages_support_page_lifecycle_has_not_been_evaluated_yet": "ליפהקיקלה יש לא היה הוערך עדיין",
  "pages.support_page.pages_support_page_linked_occasions": "מקושר אירועים",
  "pages.support_page.pages_support_page_linked_users": "מקושר משתמשים",
  "pages.support_page.pages_support_page_no_email": "אין דואל",
  "pages.support_page.pages_support_page_no_recent_communication_history": "אין אחרונים תקשורת היסטוריה",
  "pages.support_page.pages_support_page_occasion_inspections": "אירוע בדיקות",
  "pages.support_page.pages_support_page_occasion_matches": "אירוע מאטצ׳הס",
  "pages.support_page.pages_support_page_occasion_slug_actor_email_distribution_id_campaign_id": "Slug אירוע, גורם, דוא״ל, Distribution ID ו-Campaign ID",
  "pages.support_page.pages_support_page_opened": "נפתחה",
  "pages.support_page.pages_support_page_operator_posture": "מפעיל מצב",
  "pages.support_page.pages_support_page_operator_reason": "מפעיל סיבה",
  "pages.support_page.pages_support_page_planner_lifecycle": "מתכנן ליפהקיקלה",
  "pages.support_page.pages_support_page_recent_communication_history": "אחרונים תקשורת היסטוריה",
  "pages.support_page.pages_support_page_regenerate_distribution": "צור מחדש הפצה",
  "pages.support_page.pages_support_page_retry_integration_sync": "נסה שוב סנכרון אינטגרציה",
  "pages.support_page.pages_support_page_revoke_distribution": "בטל הפצה",
  "pages.support_page.pages_support_page_run_support_action": "הרץ תמיכה פעולה",
  "pages.support_page.pages_support_page_select_distribution": "בחר הפצה",
  "pages.support_page.pages_support_page_support_flows": "תמיכה תהליכים",
  "pages.support_page.pages_support_page_sync_direction": "סנכרון דירהקטיונ",
  "pages.support_page.pages_support_page_template": "תבנית",
  "pages.support_page.pages_support_page_token": "אסימון",
  "pages.support_page.pages_support_page_uncomputed": "לא מחושב",
  "pages.support_page.pages_support_page_user_ids": "User IDs",
  "pages.support_page.select_connection": "בחר חיבור",
  "pages.swagger_page.current_api_environment": "סביבת API נוכחית",
  "pages.swagger_page.navigate_to": "נאויגאטה ל",
  "pages.swagger_page.search_and_browse_the_internal_openapi_contract_for_the_current_admin_environment": "חפש ועיין בחוזה OpenAPI הפנימי עבור סביבת הניהול הנוכחית",
  "pages.swagger_page.select_section_or_endpoint": "בחר מקטע או נקודת קצה",
  "pages.webhooks_page.pages_webhooks_page_configure_a_platform_or_occasion_scoped_outbound_webhook": "הגדר Webhook יוצא בהיקף פלטפורמה או אירוע",
  "pages.webhooks_page.pages_webhooks_page_create_outbound_webhook_subscriptions_in_a_focused_overlay": "צור מנויי Webhook יוצאים בחלונית ממוקדת",
  "pages.webhooks_page.pages_webhooks_page_create_subscription": "צור מנוי",
  "pages.webhooks_page.pages_webhooks_page_endpoint_url": "URL נקודת קצה",
  "pages.webhooks_page.pages_webhooks_page_event_types": "אירוע סוגים",
  "pages.webhooks_page.pages_webhooks_page_failed_deliveries": "נכשל מסירות",
  "pages.webhooks_page.pages_webhooks_page_manage_outbound_subscriptions_and_inspect_recent_deliveries": "נהל מנויים יוצאים ובדוק מסירות אחרונות",
  "pages.webhooks_page.pages_webhooks_page_no_failure": "אין כשל",
  "pages.webhooks_page.pages_webhooks_page_no_response": "אין תגובה",
  "pages.webhooks_page.pages_webhooks_page_occasion_id": "מזהה אירוע",
  "pages.webhooks_page.pages_webhooks_page_platform": "פלטפורמה",
  "pages.webhooks_page.pages_webhooks_page_queued_deliveries": "בתור מסירות",
  "pages.webhooks_page.pages_webhooks_page_recent_deliveries": "אחרון מסירות",
  "pages.webhooks_page.pages_webhooks_page_recent_events": "אחרון אירועים",
  "pages.webhooks_page.pages_webhooks_page_required_for_occasion_scoped_subscriptions": "נדרש עבור אירוע מוגבל מנויים",
  "pages.webhooks_page.pages_webhooks_page_scope_type": "היקף סוג",
  "pages.webhooks_page.pages_webhooks_page_signing_secret": "חתימה סוד",
  "pages.webhooks_page.pages_webhooks_page_subscription_dialog": "מנוי דיאלוג",
  "pages.webhooks_page.pages_webhooks_page_subscriptions": "מנויים",
  "pages.webhooks_page.pages_webhooks_page_webhook_operations": "תפעול Webhook",
  "pages.webhooks_page.pages_webhooks_page_webhooks_are_a_first_class_integration_interface_this": "Webhooks הם ממשק אינטגרציה מרכזי בפלטפורמה זו",
  "pages.webhooks_page.partner_automation_endpoint": "שותף אוטומציה נקודת קצה",
  "pages.webhooks_page.the_webhook_management_view_could_not_be_loaded": "לא ניתן היה לטעון את תצוגת ניהול ה-Webhook",
  "tov.integrations.channel.email": "דוא״ל",
  "tov.integrations.channel.sms": "מסרונים",
  "tov.swagger.prose.006d110f1ee1": "בקשה או הרשאה לא תקינה, או סוג הרשאה שאינו נתמך.",
  "tov.swagger.prose.0073b3aa89fa": "הקשר האירוע הראשי של האורח נשלף.",
  "tov.swagger.prose.01845cebb34f": "יצירת סוכן מואצל עם הרשאות מוגבלות",
  "tov.swagger.prose.028ddf3154ac": "יצירת רשומת נכס",
  "tov.swagger.prose.03a227c15a0f": "קבלת סקירת תפעול ובקרה למנהלים",
  "tov.swagger.prose.03bb407f5d5d": "הסוכן המואצל נוצר.",
  "tov.swagger.prose.058edf55ae9d": "תגובת הסקירה הכספית לאחר יצירת לוח תשלומים.",
  "tov.swagger.prose.060b90f109c8": "מופעל כאשר מסירת webhook מגיעה למצב כשל סופי.",
  "tov.swagger.prose.06381dbcc1a7": "לקוח ה-OAuth בוטל.",
  "tov.swagger.prose.0758edbf5573": "ביטול לקוח OAuth",
  "tov.swagger.prose.0bc051d3d0e3": "השבתת לקוח OAuth",
  "tov.swagger.prose.0f5f7846f925": "מטען אתחול האורח.",
  "tov.swagger.prose.1020b619170e": "מחיקת קטגוריה כספית",
  "tov.swagger.prose.1092001b1b6b": "קבוצת הודעות שטוחה. יש להשתמש ב-tov.api.message_group; לקוחות מציגים את כל החלקים או משמרים את חלופת המקור המלאה.",
  "tov.swagger.prose.115f29392667": "רשימת אירועי משנה לאורח.",
  "tov.swagger.prose.11a8e12aff62": "הגורם המאומת אינו רשאי לגשת לנתיב.",
  "tov.swagger.prose.12876cbc4872": "רשימת לקוחות OAuth של בעלים מורשה",
  "tov.swagger.prose.129a99e275dd": "תמיד `no-cache`.",
  "tov.swagger.prose.12c99a3eee9b": "יצירת לוח תשלומים",
  "tov.swagger.prose.130614959203": "השירות מוכן.",
  "tov.swagger.prose.1327d37899dd": "רשימת נכסים הגלויים למתכנן",
  "tov.swagger.prose.139ec4400a9a": "תגובת הסקירה הכספית לאחר עדכון לוח תשלומים.",
  "tov.swagger.prose.13a7c655a7d4": "ייצור",
  "tov.swagger.prose.13d43dfdd7d3": "תגובת הסקירה הכספית.",
  "tov.swagger.prose.143a34d8b40d": "ממשק ה-API הציבורי של Tov+",
  "tov.swagger.prose.144e4e810451": "תגובת ההושבה.",
  "tov.swagger.prose.14ca94888703": "יצירת רשומת תשלום",
  "tov.swagger.prose.14cae77691ca": "שליפת הקשר אורח לפי מזהה אירוע ראשי ואסימון הזמנה",
  "tov.swagger.prose.1546bb6e8fbe": "המקום הועבר לארכיון.",
  "tov.swagger.prose.1599aafb6936": "החלת החלטת ניהול תוכן על פריט גלריה",
  "tov.swagger.prose.15cc3aceaa80": "קבלת תצורת ספק ההפניות של הפלטפורמה",
  "tov.swagger.prose.179afe8c68b8": "לקוחות OAuth בהיקף הבעלים.",
  "tov.swagger.prose.198adeee45f4": "מחזיר הקשר בטוח של הגורם המבקש, האימות, הבעלים, הנושא, ההיקף וההפעלה עבור לקוחות מאומתים אנושיים ולא אנושיים, בלי לחשוף סודות Bearer.",
  "tov.swagger.prose.1a03aaac0bdb": "סקירת ניהול webhook.",
  "tov.swagger.prose.1ad3c85b6879": "אישור בקשת הרשאת OAuth",
  "tov.swagger.prose.1d140841c22a": "מחיקת סעיף תקציבי",
  "tov.swagger.prose.1ecc19d09c4d": "החלפת מפות תוכן מתורגם של אירוע ראשי",
  "tov.swagger.prose.1f9dee35b667": "דגל התכונה לאחר העדכון.",
  "tov.swagger.prose.1fa712192e3a": "עדכון אירוע ראשי",
  "tov.swagger.prose.201d0bb5a233": "בדיקת חיות",
  "tov.swagger.prose.229242b47364": "כתובת הפניה של הרשאה שנדחתה המכילה access_denied ו-state.",
  "tov.swagger.prose.235a4b070c7a": "אירועי משנה הגלויים לאורח הוחזרו.",
  "tov.swagger.prose.235cae764aa1": "סקירת חיוב למנהלים.",
  "tov.swagger.prose.23da1b2520e0": "שליפת ההפעלה המאומתת הנוכחית",
  "tov.swagger.prose.23dda8d946af": "הוספת הרשאה מפורשת לזהות API",
  "tov.swagger.prose.26199984f6b6": "מחזיר כעת מעטפת סמן של עמוד יחיד. עימוד נוסף שמור להרחבה עתידית.",
  "tov.swagger.prose.27038404cf22": "סמני מפה לאורח.",
  "tov.swagger.prose.2a7c6cb0d2c5": "יצירת טופס",
  "tov.swagger.prose.2c5ef9e9c728": "סקירת תמיכה למנהלים.",
  "tov.swagger.prose.2ced8881d7ec": "התכונה המבוקשת דורשת זכאות חיוב פעילה.",
  "tov.swagger.prose.2d861f30366f": "יצירת קטגוריה כספית",
  "tov.swagger.prose.2e21a6e2692e": "רשימת אירועי משנה הגלויים לאורח",
  "tov.swagger.prose.2f58af02dbab": "פרטי הסוכן המואצל.",
  "tov.swagger.prose.2fcbc8b90c42": "מחיקת לוח תשלומים",
  "tov.swagger.prose.302b942bacb5": "עדכון רשומת תשלום",
  "tov.swagger.prose.31b3e702294a": "תמיד `no-store`.",
  "tov.swagger.prose.3234d8ddb0f6": "רשימת הגדרות מתאמים ופעילות שילוב באירוע ראשי",
  "tov.swagger.prose.33233a61b416": "הורדת תוצר ייצוא שהושלם לאירוע ראשי",
  "tov.swagger.prose.34dcfa99321c": "תצוגת מקומות לאורח לאחר סינון נראות.",
  "tov.swagger.prose.34e16669c35e": "עדכון חיבור שילוב קיים",
  "tov.swagger.prose.34e9fccfede1": "אסימוני רענון אינם מונפקים בכוונה בגרסה זו.",
  "tov.swagger.prose.35d07e0e0382": "JWT מסוג Bearer קצר חיים. אין לרשום ביומן או לשמור.",
  "tov.swagger.prose.35eb7d14ae93": "החלפת אישור מפתח API עם חשיפה חד-פעמית של הסוד",
  "tov.swagger.prose.36fba6ba6f85": "ממשק API התואם למימוש חוויות המתכננים, האורחים, הספקים והמנהלים הזמינות כעת ב-Tov+.\n\nמוסכמות:\n- מפתחות JSON נכתבים ב-snake_case.\n- מקטעי נתיבים נכתבים ב-kebab-case.\n- פרמטרים בנתיב נכתבים ב-snake_case.\n- נתיבי יישום מאומתים משתמשים בשכבת אימות והפעלות מרכזית.\n- נתיבי אורחים משתמשים ב-`guest_token` במחרוזת השאילתה.",
  "tov.swagger.prose.3a3338ce68fa": "מסנן קוד שפה אופציונלי. כאשר הוא מסופק, שדות JSON מתורגמים כוללים רק את מפתח השפה הזאת.",
  "tov.swagger.prose.3a52d6b2a20e": "מופעל כאשר משימת פרסום מפיקה תוצר פרסום.",
  "tov.swagger.prose.3aab0b3d2d74": "סוכנים מואצלים בהיקף הבעלים.",
  "tov.swagger.prose.3cb1ab3fae3f": "העדכון המבוקש מתנגש עם נתונים קיימים.",
  "tov.swagger.prose.3cf175ee9351": "התוכן המתורגם של אירוע המשנה לאחר העדכון.",
  "tov.swagger.prose.3d8a4db4a004": "ה-callback התקבל לעיבוד אסינכרוני.",
  "tov.swagger.prose.3e929316316b": "תגובת ציר הזמן.",
  "tov.swagger.prose.42430138e63a": "תגובת הסקירה הכספית לאחר עדכון קטגוריה.",
  "tov.swagger.prose.46f8454455ad": "מופעל כאשר ציר זמן הרלוונטי למערכות המשך משתנה באופן מהותי.",
  "tov.swagger.prose.481e66e057b5": "סקירת הפניות למתכננים מ-Partnero.",
  "tov.swagger.prose.48a378a87d42": "שליפת הקשר גישת אורח לאירוע ראשי",
  "tov.swagger.prose.493d459da99e": "יצירת מקום חדש באירוע ראשי",
  "tov.swagger.prose.4995be4dbf45": "סקירת תפעול.",
  "tov.swagger.prose.4ab8a1e2d24d": "הקשר כללי של הגורם המאומת.",
  "tov.swagger.prose.4b84616adb48": "מקומות הגלויים לאורח הוחזרו.",
  "tov.swagger.prose.4ca3e9a62808": "תגובת התכנון המשותף.",
  "tov.swagger.prose.4d3e32200c2f": "קוד אתחול האוטומציה הוחלף.",
  "tov.swagger.prose.4f674ade8e93": "ההפעלה המאומתת הראשית של היישום. פיתוח מקומי יכול להשתמש במקום זאת בהעברת כותרת מהימנה.",
  "tov.swagger.prose.516d93d72eea": "טפסים לאורח.",
  "tov.swagger.prose.52137dbdc850": "יצירת משתתף",
  "tov.swagger.prose.542d87846567": "סקירת שילובי הפלטפורמה.",
  "tov.swagger.prose.5442e84341b0": "הפעלת התשלום נוצרה.",
  "tov.swagger.prose.5480f7cfbdcb": "מלאי המקומות באירוע הראשי.",
  "tov.swagger.prose.55f8e4d9fe04": "המשתתף נוצר.",
  "tov.swagger.prose.5651faee9626": "יצירת אירוע משנה",
  "tov.swagger.prose.57faef010f7d": "סיכום אישורי הגעה והזמנות.",
  "tov.swagger.prose.58693a03593d": "המקום עודכן.",
  "tov.swagger.prose.590548bae1cd": "תמונת מצב לניפוי יכולות.",
  "tov.swagger.prose.595e6ccae4f6": "הייבוא הועבר לתור.",
  "tov.swagger.prose.5a4d2fde25c9": "רשימת טפסים הגלויים למתכנן",
  "tov.swagger.prose.5af9659c4f83": "סקירת דגלי תכונות למנהלים.",
  "tov.swagger.prose.5cb0f1dbb121": "רשימת משתתפים באירוע ראשי",
  "tov.swagger.prose.5f0ac65557d8": "תגובת הסקירה הכספית לאחר עדכון סעיף תקציבי.",
  "tov.swagger.prose.5f2f03ecf104": "לקוח ה-OAuth הושבת.",
  "tov.swagger.prose.5f30aa8dec98": "קבלת המודולים המותקנים באירוע ראשי",
  "tov.swagger.prose.5f52817f3669": "מטען אתחול האורח הוחזר.",
  "tov.swagger.prose.616284775311": "יצירת זהות API",
  "tov.swagger.prose.61db9b3ed52a": "עדכון לוח תשלומים",
  "tov.swagger.prose.62380893f75d": "מטען Base64 לתמונת פרופיל מסוג png/jpeg/webp.",
  "tov.swagger.prose.629e6443bed3": "החלפת תצורת השפות של אירוע ראשי",
  "tov.swagger.prose.6373a334b6ec": "פרטי האירוע הראשי.",
  "tov.swagger.prose.640b9c769902": "רשימת פריטי ציר זמן למתכנן",
  "tov.swagger.prose.6436c9794f13": "מופעל כאשר נכס לאחר ניהול תוכן נעשה רלוונטי חיצונית.",
  "tov.swagger.prose.64477f977e6a": "קבלת הקשר אישורי הגעה למתכנן",
  "tov.swagger.prose.644ac74be22c": "מצב השילוב של האירוע הראשי הוחזר.",
  "tov.swagger.prose.655924d1b13c": "קבלת נתוני דיווח כספי מסוכמים למתכנן",
  "tov.swagger.prose.65610216b1b0": "פרטי זהות ה-API.",
  "tov.swagger.prose.6572c5f84851": "קבלת הקשר אישורי הגעה לאורח",
  "tov.swagger.prose.65c7a21c4bec": "תגובת הגלריה.",
  "tov.swagger.prose.65e2823d0e3c": "אירוע המשנה נוצר.",
  "tov.swagger.prose.66ebea08d143": "רשימת משימות AI למתכננים",
  "tov.swagger.prose.682ce91b956c": "השירות פעיל.",
  "tov.swagger.prose.696fc7d42d2d": "רשימת זהויות API של בעלים מורשה",
  "tov.swagger.prose.69905aa7fc57": "העברת מקום לארכיון",
  "tov.swagger.prose.6b9b25002ad9": "יצירת מנוי webhook",
  "tov.swagger.prose.6d38396e653a": "סמני מפה של מקומות הגלויים לאורח הוחזרו.",
  "tov.swagger.prose.6dd537754f03": "העברת ייצוא אירוע ראשי לתור",
  "tov.swagger.prose.6de43e96d18d": "ממשק ה-API של Tov+",
  "tov.swagger.prose.6e5ad6c1d73c": "ריצת הגיבוי הועברה לתור.",
  "tov.swagger.prose.6e5de30a6244": "קבלת סקירת דגלי תכונות למנהלים",
  "tov.swagger.prose.6ebe1ae98031": "סקירת ייצוא וייבוא של אירוע ראשי אחד.",
  "tov.swagger.prose.7055b6263206": "השבתת זהות API והאישורים הפעילים שלה",
  "tov.swagger.prose.70713d67633a": "קבלת נתוני שרת הרשאות OAuth",
  "tov.swagger.prose.708a3570c76b": "יצירת סעיף תקציבי",
  "tov.swagger.prose.7102d0075c77": "נדרש להרשאות רחבות או רגישות של זהויות API.",
  "tov.swagger.prose.720766c798de": "תוצר הייצוא בפורמט JSON.",
  "tov.swagger.prose.727919451c49": "האירוע הראשי נוצר.",
  "tov.swagger.prose.73714af24022": "יצירת הפעלת תשלום למתכננים",
  "tov.swagger.prose.73a4977df880": "תגובת הפרסום.",
  "tov.swagger.prose.768abd1e0e91": "תגובת הסקירה הכספית לאחר העדכון.",
  "tov.swagger.prose.76ac4bb16b4b": "נדרש אימות, או שהאישור אינו תקין.",
  "tov.swagger.prose.76dd180d9ea3": "יצירת אירוע ראשי",
  "tov.swagger.prose.76edb1b52666": "רשימת טפסים המיועדים לאורח באירוע ראשי",
  "tov.swagger.prose.776c529220b0": "רשימת אירועי משנה.",
  "tov.swagger.prose.7851485349b6": "המשאב המבוקש לא נמצא.",
  "tov.swagger.prose.78d9839484e0": "הייצוא הועבר לתור.",
  "tov.swagger.prose.79096ac9c5c6": "תגובת הסקירה הכספית לאחר יצירת רשומת תשלום.",
  "tov.swagger.prose.79616808bf82": "זהות ה-API הושבתה.",
  "tov.swagger.prose.7a68476f9ca7": "סקירת ניהול תוכן.",
  "tov.swagger.prose.7aaffcc068f9": "זהות ה-API נוצרה.",
  "tov.swagger.prose.7e375d81a8c8": "קטלוג משימות AI לאורחים.",
  "tov.swagger.prose.7e399ea0f0a8": "רישום לקוח OAuth עם כתובות הפניה מדויקות",
  "tov.swagger.prose.7e8eb03ba3bb": "הקשר גישת האורח.",
  "tov.swagger.prose.7f020cd1a432": "דחיית בקשת הרשאת OAuth",
  "tov.swagger.prose.7fb3c6d4599d": "הסוכן המואצל בוטל.",
  "tov.swagger.prose.81082b72f2e4": "אישור ההגעה התקבל.",
  "tov.swagger.prose.818b29d85347": "בדיקת מנויי webhook, אירועים ומסירות",
  "tov.swagger.prose.81ae18847c9f": "האירוע הראשי לאחר העדכון.",
  "tov.swagger.prose.82df8608082d": "תגובת הסקירה הכספית לאחר מחיקת סעיף תקציבי.",
  "tov.swagger.prose.837a0ed360de": "רשימת אירועי משנה הגלויים למתכנן באירוע ראשי",
  "tov.swagger.prose.839bece5b5f0": "שפות האירוע הראשי לאחר העדכון.",
  "tov.swagger.prose.8578a62bcd7b": "טעינת מטען האתחול של האורח באירוע ראשי",
  "tov.swagger.prose.88ebcebcf3a0": "קבלת מצב התרגום של אירוע ראשי",
  "tov.swagger.prose.88f068e20dfd": "תגובת הסקירה הכספית לאחר מחיקת רשומת תשלום.",
  "tov.swagger.prose.89dad3ee70ee": "סקירת גיבוי.",
  "tov.swagger.prose.8bc58b0722fb": "הקשר ההפעלה המאומתת לאחר העדכון.",
  "tov.swagger.prose.8cf992a247bd": "קבלת סוכן מואצל",
  "tov.swagger.prose.8d0d08b30144": "קבלת אירוע ראשי יחיד",
  "tov.swagger.prose.8dd14f088e08": "קבלת מודל ההרשאות של האירוע הראשי",
  "tov.swagger.prose.8e7ed6ee5995": "קבלת לוחות ופריטי תכנון משותף",
  "tov.swagger.prose.8ef5c071bfeb": "תמונת מצב של ההרשאות.",
  "tov.swagger.prose.90505056d940": "עדכון סעיף תקציבי",
  "tov.swagger.prose.91227b1e8ea6": "תגובת הסקירה הכספית לאחר מחיקת קטגוריה.",
  "tov.swagger.prose.91508e7241f5": "רשימת אירועים ראשיים.",
  "tov.swagger.prose.916e33b00665": "תגובת אישורי הגעה לאורח.",
  "tov.swagger.prose.9221ad716ca3": "נדרשת הפעלת Keycloak מאומתת וחברות בקבוצת מנהלי הפלטפורמה שהוגדרה.",
  "tov.swagger.prose.92bb50afc1e8": "פיתוח מקומי",
  "tov.swagger.prose.92d7dedff96d": "רשימת פריטי גלריה לניהול תוכן ולבדיקת המתכנן",
  "tov.swagger.prose.95fea140e184": "JWKS ציבורי לאימות אסימוני גישה מסוג OAuth עם RS256.",
  "tov.swagger.prose.98000fd37945": "קבלת מטעני callback נכנסים משותפים",
  "tov.swagger.prose.98ee60b200a9": "העברת תמונת מצב של מניפסט שחזור לתור",
  "tov.swagger.prose.993a754dd824": "רשימת טפסים.",
  "tov.swagger.prose.99678e0ca546": "קבלת פיקוח חיוב ברמת הפלטפורמה",
  "tov.swagger.prose.99d58936af2c": "העברת ייבוא אירוע ראשי לתור",
  "tov.swagger.prose.9a164c03df70": "תגובת הסקירה הכספית לאחר יצירת סעיף תקציבי.",
  "tov.swagger.prose.9aa8f384244f": "החלפת קוד הרשאת OAuth באסימון גישה",
  "tov.swagger.prose.9d4a93b4e6b6": "מופעל כאשר מצב משתתף או הזמנה המיועדים לאורח משתנה באופן מהותי.",
  "tov.swagger.prose.9debcb695892": "מופעל כאשר תוכנית הושבה מפורסמת או מפורסמת מחדש.",
  "tov.swagger.prose.9e5e36b59eca": "רשימת התקנות מודולים.",
  "tov.swagger.prose.9efdc9a5f3af": "עדכון מצב ההשקה של דגל תכונה",
  "tov.swagger.prose.9f654fbd2ffb": "רשימת מקומות באירוע ראשי",
  "tov.swagger.prose.a0b40059b15d": "קטלוג webhooks יוצאים התואם למימוש תשתית ה-webhook הנוכחית של Tov+.\n\nהערות:\n- מפתחות אירועים משתמשים בשמות עסקיים באותיות קטנות המופרדים בנקודות\n- מעטפות המטען משתמשות ב-snake_case\n- המסירה חתומה ומתבצעת לפחות פעם אחת",
  "tov.swagger.prose.a178f9967186": "תגובת הסקירה הכספית לאחר מחיקת לוח תשלומים.",
  "tov.swagger.prose.a19a8695b2e3": "רשימת טפסים הגלויים לאורח",
  "tov.swagger.prose.a1f34d28043f": "עוגיית הפעלת זהות חתומה עבור דמות הבדיקה.",
  "tov.swagger.prose.a25ebe77bc01": "לקוח ה-OAuth נרשם.",
  "tov.swagger.prose.a27e41535064": "קבלת סקירת גיבוי ושחזור",
  "tov.swagger.prose.a3aa9ce1842b": "רשימת סוכנים מואצלים של בעלים מורשה",
  "tov.swagger.prose.a47009674834": "קבלת סקירת חיוב למתכננים",
  "tov.swagger.prose.a580950d11d0": "שליפת הקשר כללי של גורם מאומת",
  "tov.swagger.prose.a6fc157ef031": "פעילות זהות ה-API.",
  "tov.swagger.prose.a82fbc20d894": "קבלת מפתחות חתימה של אסימוני גישה ל-OAuth",
  "tov.swagger.prose.a87fecf586d7": "רשימת סמני מפה של מקומות הגלויים לאורח",
  "tov.swagger.prose.a8e7ac92a116": "סביבת בדיקות",
  "tov.swagger.prose.a92eff5f4f2c": "תגובת התרגום.",
  "tov.swagger.prose.a9cba172066e": "תצורת שילוב ההפניות למנהלים.",
  "tov.swagger.prose.aaf3620fa501": "כתובת הפניה של הרשאה מאושרת המכילה code ו-state.",
  "tov.swagger.prose.abcd958ba9f4": "הרשאת זהות ה-API נוצרה.",
  "tov.swagger.prose.acfa924d06fe": "עדכון קטגוריה כספית",
  "tov.swagger.prose.aeafa2765877": "מנוי ה-webhook נוצר.",
  "tov.swagger.prose.aee00c271b82": "מחזיר את הקשר גישת האורח יחד עם נתוני האירועים והטפסים הראשוניים המשמשים לטעינת דף הבית של מעטפת האורחים. התגובות מוגשות עם מטמון פרטי קצר ומטמון שרת מוגבל להיקף.",
  "tov.swagger.prose.af406639c87b": "חיבור השילוב נוצר.",
  "tov.swagger.prose.af7a5ab52420": "עדכון התצורה הכספית של האירוע הראשי",
  "tov.swagger.prose.afffd25de314": "צפייה בסקירת שילובים ברמת הפלטפורמה",
  "tov.swagger.prose.b1a362684ab6": "החלפת קוד אתחול חד-פעמי לאוטומציה בעוגיית הפעלה לדפדפן",
  "tov.swagger.prose.b1fc61b87d15": "אסימון גישה מסוג Bearer קצר חיים המוגבל לקהל יעד.",
  "tov.swagger.prose.b39c82d45adc": "מנוי ה-webhook עודכן.",
  "tov.swagger.prose.b3ab9d403cc5": "הורדת מניפסט שחזור",
  "tov.swagger.prose.b5fd88c33e61": "קבלת סקירת ייצוא וייבוא לאירוע ראשי",
  "tov.swagger.prose.b7296d96bb0c": "רשימת פעילות מחזור החיים של זהות API",
  "tov.swagger.prose.b75059733967": "רשימת מקומות הגלויים לאורח",
  "tov.swagger.prose.b7917656a611": "הטופס נוצר.",
  "tov.swagger.prose.b8b356ab8355": "רשימת הגדרות מתאמים, חיבורי אירוע ראשי ופעילות שילוב אחרונה",
  "tov.swagger.prose.bae19ee860fa": "קטלוג משימות AI למתכננים.",
  "tov.swagger.prose.bc87ce736600": "חיבור השילוב עודכן.",
  "tov.swagger.prose.bcdf4c4708a1": "שליפת מצב אבטחת החשבון הנוכחי",
  "tov.swagger.prose.bd97053143e7": "החלפת מפות תוכן מתורגם של אירוע משנה",
  "tov.swagger.prose.bdcd7c476604": "תגובת הסקירה הכספית לאחר עדכון רשומת תשלום.",
  "tov.swagger.prose.bf291b9943e4": "הודעת קטלוג אופציונלית; message נשארת חלופת התאימות באנגלית.",
  "tov.swagger.prose.c01cfb5558e6": "מופעל כאשר תשובת אישור הגעה נשלחת או מסתיימת.",
  "tov.swagger.prose.c0aebb010a52": "קבלת סקירה כספית למתכנן",
  "tov.swagger.prose.c105fe43d5d2": "תת-קבוצה של ממשק ה-API של Tov+ המיועדת לשילובים ציבוריים.\n\nנכללים כאן:\n- נתיבי קריאה ושליחה המיועדים לאורחים\n- תהליכי חיבור שילובים ציבוריים\n- נקודות קצה של callback לשותפים\n\nלא נכללים כאן:\n- ממשקי API למנהלים\n- נתיבי תמיכה ותפעול פנימיים\n- נקודות קצה מקומיות בלבד וניפוי פלטפורמה",
  "tov.swagger.prose.c14b0d72fd05": "מחיקת הקטגוריה נחסמה עקב כללי התקינות הכספית.",
  "tov.swagger.prose.c3724d674821": "מאמת לקוח OAuth רשום, כתובת הפניה מדויקת, היקף ומשאב מבוקשים ואתגר S256 PKCE, ואז מחזיר נתוני הסכמה שהמשתמש האנושי המאומת יכול לאשר או לדחות.",
  "tov.swagger.prose.c37f1e6346b4": "עדכון מחזור החיים, התצורה או פרטי האימות של חיבור",
  "tov.swagger.prose.c40370881c86": "מטען פרטי המקום.",
  "tov.swagger.prose.c4392e31ad6a": "שליפת מטען האתחול הראשוני של חוויית האורח",
  "tov.swagger.prose.c5b349eaaffa": "מחזיר את תוצאת הכרעת היכולות הנוכחית בהיקף החשבון או האירוע הראשי, כולל הסברים, חריגות ויומני ניפוי אחרונים.",
  "tov.swagger.prose.c5ebd396d8d3": "ביצוע משימת AI לאורחים",
  "tov.swagger.prose.c63b6e512686": "מופעל כאשר תזכורת נמסרת בהצלחה.",
  "tov.swagger.prose.c6734f4a61c5": "אסימון הזמנת אורח המשמש נתיבי קריאה ושליחה המיועדים לאורחים.",
  "tov.swagger.prose.c8b3bbca2371": "אתחול האוטומציה הונפק. קוד האתחול נחשף פעם אחת.",
  "tov.swagger.prose.c96f998b2c77": "קבלת זהות API עם נתוני אישורים בטוחים",
  "tov.swagger.prose.c9888327503c": "קבלת סקירת הפניות ושותפים למתכננים",
  "tov.swagger.prose.cb7e37e12526": "תגובת מכלול המודל הבסיסי בגרסה 2.",
  "tov.swagger.prose.cc3ac33eb3ec": "מחיקת רשומת תשלום",
  "tov.swagger.prose.cd58f60a66d8": "הנכס נוצר.",
  "tov.swagger.prose.ce9f95c45d8d": "מופעל כאשר אצוות סנכרון של שילוב מסתיימת.",
  "tov.swagger.prose.ceddb1891e4a": "סקירת חיוב למתכננים.",
  "tov.swagger.prose.cede5445e3f7": "קבלת מכלול המודל הבסיסי המעודכן של אירוע ראשי",
  "tov.swagger.prose.cf1fa174aa46": "רשימת מקומות הגלויים לאורח באירוע ראשי",
  "tov.swagger.prose.cf69a3070325": "מפתח ה-API הוחלף. הסוד החלופי מוחזר רק בתגובה זו.",
  "tov.swagger.prose.cf98b39a37c1": "קבלת משימות ותוצרי פרסום",
  "tov.swagger.prose.d1f9f2a45943": "מניפסט הגיבוי בפורמט JSON.",
  "tov.swagger.prose.d2c69fb646b0": "התוכן המתורגם של האירוע הראשי לאחר העדכון.",
  "tov.swagger.prose.d33b944560c5": "שליחת אישור הגעה של אורח",
  "tov.swagger.prose.d39f61386552": "ביטול אישור מפתח API",
  "tov.swagger.prose.d3d1bf676f1b": "שליחת אישור הגעה דרך תהליך האורח",
  "tov.swagger.prose.d42a58394b45": "תוצאת משימת AI לאורחים.",
  "tov.swagger.prose.d44d3ebfecc4": "בדיקת מוכנות",
  "tov.swagger.prose.d555ccd25192": "תגובת הביקורת למנהלים.",
  "tov.swagger.prose.d67a8629d402": "רשימת משתתפים.",
  "tov.swagger.prose.d9b079a616b8": "טפסים המיועדים לאורח הוחזרו.",
  "tov.swagger.prose.da383fad44a6": "חיפוש הקשר תמיכה למנהלים במשתמשים ובאירועים ראשיים",
  "tov.swagger.prose.da5027fe2a88": "ביטול סוכן מואצל",
  "tov.swagger.prose.da9fb77a1471": "תגובת הדיווח הכספי.",
  "tov.swagger.prose.dac5ea70743f": "רשימת אירועי משנה הגלויים לאורח באירוע ראשי",
  "tov.swagger.prose.dbe8ba85893b": "קבלת נתוני ביקורת הרשאות למנהלים",
  "tov.swagger.prose.dc08b9fc6789": "מצב מסגרת השילוב של האירוע הראשי.",
  "tov.swagger.prose.dc9250adb8c8": "רשימת אירועים ראשיים הגלויים לגורם הנוכחי",
  "tov.swagger.prose.dd1aae525f14": "עדכון פרופיל החשבון המאומת הנוכחי",
  "tov.swagger.prose.df31887bc5eb": "מצב אבטחת החשבון הנוכחי.",
  "tov.swagger.prose.df684adca648": "תגובת הסקירה הכספית לאחר יצירת קטגוריה.",
  "tov.swagger.prose.dfaeeac6c6a3": "קבלת תור ניהול תוכן הגלריה למנהלים",
  "tov.swagger.prose.e0f98bf95251": "קבלת מקום עם קישורים, נראות, מקומות משניים ושכבות",
  "tov.swagger.prose.e1d0d4293a97": "הקשר ההפעלה המאומתת.",
  "tov.swagger.prose.e2e03cab95ba": "יצירת אישור מפתח API עם חשיפה חד-פעמית של הסוד",
  "tov.swagger.prose.e3b05ab5bcb4": "עדכון מקום",
  "tov.swagger.prose.e42ca9c0233e": "התחלת בקשת הרשאת OAuth",
  "tov.swagger.prose.e4f795cebce5": "יצירת חיבור שילוב בהיקף אירוע ראשי",
  "tov.swagger.prose.e5b409d7b77f": "פריט הגלריה לאחר ניהול התוכן.",
  "tov.swagger.prose.e75ae43d7cb3": "ביצוע משימת AI למתכננים",
  "tov.swagger.prose.e76860c7d40a": "זהויות API בהיקף הבעלים.",
  "tov.swagger.prose.e8aaf781c8b4": "נתוני הסכמה לעסקת הרשאת OAuth ממתינה.",
  "tov.swagger.prose.e940fa732c3b": "אימות הבקשה נכשל.",
  "tov.swagger.prose.e9f52c816ea8": "הנפקת קוד אתחול להפעלת אוטומציה שאינה בייצור",
  "tov.swagger.prose.eb79ca5e1f36": "עדכון מנוי webhook",
  "tov.swagger.prose.ebc81c4f7999": "המקום נוצר.",
  "tov.swagger.prose.ec3434644adc": "תומך בהחלפת אסימונים באמצעות Authorization Code עם PKCE ללקוחות OAuth/MCP רשומים. בגרסה זו לא מונפקים אסימוני רענון.",
  "tov.swagger.prose.ed3a26fad5b6": "רשימת נכסים.",
  "tov.swagger.prose.ee3ee367e9b8": "רשימת משימות AI לאורחים",
  "tov.swagger.prose.ef461fe6b214": "אישור ההגעה התקבל.",
  "tov.swagger.prose.f3cdda6dabf7": "תוצאת משימת AI למתכננים.",
  "tov.swagger.prose.f44362128c8d": "webhooks של Tov+",
  "tov.swagger.prose.f541414b8ebb": "מפתח ה-API נוצר. הסוד מוחזר רק בתגובה זו.",
  "tov.swagger.prose.f5fda73bdf9d": "מחזיר מידע בטוח על החשבון, ההפעלה, זהויות מקושרות, שיטת הכניסה וקישורי ניהול חשבון Keycloak של המשתמש האנושי הנוכחי. Tov+ אינו חושף או שומר סודות אימות של משתמשים אנושיים.",
  "tov.swagger.prose.f7e860cb1bb3": "קבלת תמונת מצב מלאה של הכרעת יכולות",
  "tov.swagger.prose.f7f762c1b50d": "פורמט מפתח API לגורם ב-Tov+. סודות מלאים מוחזרים פעם אחת בלבד ביצירת אישור או בהחלפתו.",
  "tov.swagger.prose.f88168c1c16c": "קבלת מצב ההושבה למתכנן",
  "tov.swagger.prose.fa8d99359669": "האישור בוטל.",
  "tov.swagger.prose.ffc3db3d62ac": "נתוני גילוי של שרת הרשאות OAuth.",
  "ui.opening_experience.storybook_description": "ספר סיפורים"
}
